webpackJsonp([1],{

/***/ "/kTh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
//
//
//
//
//
//
//

/* harmony default export */ var streetViewPanorama = ((function (x) {
  return x.default || x;
})(__webpack_require__("8ebl")));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50f7f8d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_streetViewPanorama = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/streetViewPanorama.vue
function injectStyle (ssrContext) {
  __webpack_require__("CjMs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  streetViewPanorama,
  components_streetViewPanorama,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dist_components_streetViewPanorama = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0Flw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiOnClickOutside.vue
//

/* harmony default export */ var UiOnClickOutside = ({
  name: 'UiOnClickOutside',
  props: ['do'],
  mounted: function mounted() {
    var _this = this;

    var listener = function listener(e) {
      if (e.target !== _this.$el && !_this.$el.contains(e.target)) {
        _this.do();
      }
    };
    document.addEventListener('click', listener, true);
    this.$once('hook:destroyed', function () {
      document.removeEventListener('click', listener, true);
    });
  },
  render: function render() {
    return this.$slots.default[0];
  }
});
// CONCATENATED MODULE: ./src/components/UiOnClickOutside.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  UiOnClickOutside,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_UiOnClickOutside = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiBaseMenuDropdown.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiBaseMenuDropdown = ({
  name: 'UiBaseMenuDropdown',
  props: {
    autoClose: {
      type: Boolean,
      default: true
    },
    listType: {
      type: Boolean,
      default: true
    }
  },

  components: {
    UiOnClickOutside: components_UiOnClickOutside
  },

  data: function data() {
    return {
      isShown: false
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.isShown = !this.isShown;
    },
    hideContent: function hideContent() {
      if (this.isShown) this.isShown = false;
    }
  },

  mounted: function mounted() {
    if (!this.$slots.default) {
      throw new Error('Please define default slot content!');
    }
    if (this.listType && this.$slots.default[0].tag !== 'ul') {
      throw new Error('Wrong template! Please use <ul> tag as default slot to define menu list:\n      <UiMenu>\n        <ul>\n          <li>hello</li>\n          <li>bye</li>\n        </ul>\n      <UiMenu>\n      ');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65847e21","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiBaseMenuDropdown.vue
var UiBaseMenuDropdown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiOnClickOutside',{attrs:{"do":_vm.hideContent}},[_c('div',{staticClass:"ui-base-menu-dropdown component"},[_c('div',{staticClass:"icon-wrapper",on:{"click":_vm.toggleMenu}},[_vm._t("icon",[_c('div',{staticClass:"default-menu-icon menu-trigger"},[_c('div',{staticClass:"menu-line top"}),_vm._v(" "),_c('div',{staticClass:"menu-line middle"}),_vm._v(" "),_c('div',{staticClass:"menu-line bottom"})])])],2),_vm._v(" "),(_vm.isShown)?_c('div',{staticClass:"content",on:{"click":_vm.hideContent}},[_vm._t("default")],2):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: UiBaseMenuDropdown_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_UiBaseMenuDropdown = (esExports);
// CONCATENATED MODULE: ./src/components/UiBaseMenuDropdown.vue
function injectStyle (ssrContext) {
  __webpack_require__("Kiyy")
}
var UiBaseMenuDropdown_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiBaseMenuDropdown___vue_template_functional__ = false
/* styles */
var UiBaseMenuDropdown___vue_styles__ = injectStyle
/* scopeId */
var UiBaseMenuDropdown___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UiBaseMenuDropdown___vue_module_identifier__ = null
var UiBaseMenuDropdown_Component = UiBaseMenuDropdown_normalizeComponent(
  UiBaseMenuDropdown,
  components_UiBaseMenuDropdown,
  UiBaseMenuDropdown___vue_template_functional__,
  UiBaseMenuDropdown___vue_styles__,
  UiBaseMenuDropdown___vue_scopeId__,
  UiBaseMenuDropdown___vue_module_identifier__
)

/* harmony default export */ var src_components_UiBaseMenuDropdown = (UiBaseMenuDropdown_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiHeaderDropdownMenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiHeaderDropdownMenu = ({
  name: 'UiHeaderDropdownMenu',
  components: { UiBaseMenuDropdown: src_components_UiBaseMenuDropdown }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2799c49f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiHeaderDropdownMenu.vue
var UiHeaderDropdownMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-header-dropdown-menu component"},[_vm._m(0),_vm._v(" "),_c('UiBaseMenuDropdown',[_c('ul',{staticClass:"menu"},[_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{ name: 'index' },"exact":""}},[_vm._v("home")])],1),_vm._v(" "),_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{ name: 'intro' }}},[_vm._v("intro")])],1),_vm._v(" "),_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{ name: 'portfolio' }}},[_vm._v("portfolio")])],1),_vm._v(" "),_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{ name: 'contact' }}},[_vm._v("contact")])],1)])])],1)}
var UiHeaderDropdownMenu_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-trigger"},[_c('div',{staticClass:"close-line left"}),_vm._v(" "),_c('div',{staticClass:"close-line right"})])}]
var UiHeaderDropdownMenu_esExports = { render: UiHeaderDropdownMenu_render, staticRenderFns: UiHeaderDropdownMenu_staticRenderFns }
/* harmony default export */ var components_UiHeaderDropdownMenu = (UiHeaderDropdownMenu_esExports);
// CONCATENATED MODULE: ./src/components/UiHeaderDropdownMenu.vue
function UiHeaderDropdownMenu_injectStyle (ssrContext) {
  __webpack_require__("lpCi")
}
var UiHeaderDropdownMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiHeaderDropdownMenu___vue_template_functional__ = false
/* styles */
var UiHeaderDropdownMenu___vue_styles__ = UiHeaderDropdownMenu_injectStyle
/* scopeId */
var UiHeaderDropdownMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UiHeaderDropdownMenu___vue_module_identifier__ = null
var UiHeaderDropdownMenu_Component = UiHeaderDropdownMenu_normalizeComponent(
  UiHeaderDropdownMenu,
  components_UiHeaderDropdownMenu,
  UiHeaderDropdownMenu___vue_template_functional__,
  UiHeaderDropdownMenu___vue_styles__,
  UiHeaderDropdownMenu___vue_scopeId__,
  UiHeaderDropdownMenu___vue_module_identifier__
)

/* harmony default export */ var src_components_UiHeaderDropdownMenu = (UiHeaderDropdownMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiToast.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiToast = ({
  name: 'UiToast',
  props: {
    item: {
      type: Object
    }
  },

  methods: {
    remove: function remove() {
      this.$emit('remove', this.item.id);
    }
  },

  computed: {
    classList: function classList() {
      return {
        default: this.item.type === 'default',
        success: this.item.type === 'success',
        info: this.item.type === 'info',
        warning: this.item.type === 'warning',
        error: this.item.type === 'error'
      };
    }
  },

  mounted: function mounted() {
    var _this = this;

    if (this.item.duration) {
      var timer = setTimeout(function () {
        clearTimeout(timer);
        _this.remove();
      }, this.item.duration);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a5d6c74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiToast.vue
var UiToast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-toast component",class:_vm.classList,on:{"click":_vm.remove}},[_vm._v("\n  "+_vm._s(_vm.item.message)+"\n")])}
var UiToast_staticRenderFns = []
var UiToast_esExports = { render: UiToast_render, staticRenderFns: UiToast_staticRenderFns }
/* harmony default export */ var components_UiToast = (UiToast_esExports);
// CONCATENATED MODULE: ./src/components/UiToast.vue
function UiToast_injectStyle (ssrContext) {
  __webpack_require__("36Ip")
}
var UiToast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiToast___vue_template_functional__ = false
/* styles */
var UiToast___vue_styles__ = UiToast_injectStyle
/* scopeId */
var UiToast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UiToast___vue_module_identifier__ = null
var UiToast_Component = UiToast_normalizeComponent(
  UiToast,
  components_UiToast,
  UiToast___vue_template_functional__,
  UiToast___vue_styles__,
  UiToast___vue_scopeId__,
  UiToast___vue_module_identifier__
)

/* harmony default export */ var src_components_UiToast = (UiToast_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiToastList.vue
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var UiToastList = ({
  name: 'UiToastList',

  components: {
    UiToast: src_components_UiToast
  },

  watch: {
    '$route': {
      handler: 'clearToastList',
      deep: 'true'
    }
  },

  computed: {
    toastsList: function toastsList() {
      return this.$store.state.toast.toastsList;
    }
  },

  methods: {
    onRemove: function onRemove(id) {
      this.$store.commit('toast/REMOVE', { id: id });
    },
    clearToastList: function clearToastList() {
      if (this.toastsList.length) {
        this.$store.commit('toast/CLEAR_LIST');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e432dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiToastList.vue
var UiToastList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"ui-toast-list component",attrs:{"name":"slide","tag":"div"}},_vm._l((_vm.toastsList),function(item){return _c('UiToast',{key:item.id,attrs:{"item":item},on:{"remove":_vm.onRemove}})}),1)}
var UiToastList_staticRenderFns = []
var UiToastList_esExports = { render: UiToastList_render, staticRenderFns: UiToastList_staticRenderFns }
/* harmony default export */ var components_UiToastList = (UiToastList_esExports);
// CONCATENATED MODULE: ./src/components/UiToastList.vue
function UiToastList_injectStyle (ssrContext) {
  __webpack_require__("DK+H")
}
var UiToastList_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiToastList___vue_template_functional__ = false
/* styles */
var UiToastList___vue_styles__ = UiToastList_injectStyle
/* scopeId */
var UiToastList___vue_scopeId__ = "data-v-05e432dc"
/* moduleIdentifier (server only) */
var UiToastList___vue_module_identifier__ = null
var UiToastList_Component = UiToastList_normalizeComponent(
  UiToastList,
  components_UiToastList,
  UiToastList___vue_template_functional__,
  UiToastList___vue_styles__,
  UiToastList___vue_scopeId__,
  UiToastList___vue_module_identifier__
)

/* harmony default export */ var src_components_UiToastList = (UiToastList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/write.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var write = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8e9a004","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/write.vue
var write_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 18 18"}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{attrs:{"d":"M16.001 11a1 1 0 0 0-1 1v2.5a.5.5 0 0 1-.5.5H3.499a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h2.5a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h14.002a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M13.169 3.403l1.429 1.429L8.65 11H7V9.35l6.169-5.947zM13.182 1a.994.994 0 0 0-.706.292L5 8.5V13h4.501l7.209-7.475a.997.997 0 0 0 0-1.411l-2.822-2.822A.992.992 0 0 0 13.183 1z"}})])])}
var write_staticRenderFns = []
var write_esExports = { render: write_render, staticRenderFns: write_staticRenderFns }
/* harmony default export */ var icons_write = (write_esExports);
// CONCATENATED MODULE: ./src/components/icons/write.vue
var write_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var write___vue_template_functional__ = false
/* styles */
var write___vue_styles__ = null
/* scopeId */
var write___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var write___vue_module_identifier__ = null
var write_Component = write_normalizeComponent(
  write,
  icons_write,
  write___vue_template_functional__,
  write___vue_styles__,
  write___vue_scopeId__,
  write___vue_module_identifier__
)

/* harmony default export */ var components_icons_write = (write_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/moon.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var moon = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04d6f702","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/moon.vue
var moon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 18 18"}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{attrs:{"d":"M7.246 3.255a6.046 6.046 0 0 0-.198 2.597 5.988 5.988 0 0 0 7.672 4.892c-.674 2.215-2.642 3.926-4.973 4.21a5.994 5.994 0 0 1-5.248-1.977C3.347 11.673 2.83 9.99 3.042 8.238c.284-2.335 1.992-4.307 4.204-4.982zM8.985 1a8.15 8.15 0 0 0-1.104.075c-3.543.48-6.388 3.364-6.82 6.92C.469 12.862 4.245 17 8.985 17c.33 0 .665-.02 1.003-.062 3.549-.433 6.428-3.283 6.907-6.833.052-.383.076-.761.075-1.134-.002-.583-.482-.972-.996-.972a1.02 1.02 0 0 0-.614.207 3.96 3.96 0 0 1-2.383.793c-.188 0-.38-.013-.574-.04-1.732-.242-3.137-1.649-3.378-3.385a3.997 3.997 0 0 1 .751-2.963c.415-.657.025-1.609-.764-1.612h-.028z"}})])])}
var moon_staticRenderFns = []
var moon_esExports = { render: moon_render, staticRenderFns: moon_staticRenderFns }
/* harmony default export */ var icons_moon = (moon_esExports);
// CONCATENATED MODULE: ./src/components/icons/moon.vue
var moon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var moon___vue_template_functional__ = false
/* styles */
var moon___vue_styles__ = null
/* scopeId */
var moon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var moon___vue_module_identifier__ = null
var moon_Component = moon_normalizeComponent(
  moon,
  icons_moon,
  moon___vue_template_functional__,
  moon___vue_styles__,
  moon___vue_scopeId__,
  moon___vue_module_identifier__
)

/* harmony default export */ var components_icons_moon = (moon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/done.vue
//
//
//
//
//
//
//
//
//

/* harmony default export */ var done = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-235f0341","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/done.vue
var done_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 512 512"}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{attrs:{"d":"M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"}})])])}
var done_staticRenderFns = []
var done_esExports = { render: done_render, staticRenderFns: done_staticRenderFns }
/* harmony default export */ var icons_done = (done_esExports);
// CONCATENATED MODULE: ./src/components/icons/done.vue
var done_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var done___vue_template_functional__ = false
/* styles */
var done___vue_styles__ = null
/* scopeId */
var done___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var done___vue_module_identifier__ = null
var done_Component = done_normalizeComponent(
  done,
  icons_done,
  done___vue_template_functional__,
  done___vue_styles__,
  done___vue_scopeId__,
  done___vue_module_identifier__
)

/* harmony default export */ var components_icons_done = (done_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/arrowDown.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var arrowDown = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b4f94c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/arrowDown.vue
var arrowDown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 22 35"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M21.7,23.3L20.4,22c-0.4-0.4-0.9-0.4-1.3,0l-6.3,6.3V1.3c0-0.5-0.3-1-0.9-1.1h-1.8C9.4,0.3,9.2,0.8,9.2,1.3v26.9L2.9,22\n\tc-0.4-0.4-0.9-0.4-1.3,0l-1.3,1.3c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.2,0.1,0.5,0.3,0.6l10,10c0.2,0.2,0.4,0.3,0.6,0.3s0.5-0.1,0.6-0.3\n\tl10-10c0.2-0.2,0.3-0.4,0.3-0.6C21.9,23.7,21.8,23.4,21.7,23.3z"}})])}
var arrowDown_staticRenderFns = []
var arrowDown_esExports = { render: arrowDown_render, staticRenderFns: arrowDown_staticRenderFns }
/* harmony default export */ var icons_arrowDown = (arrowDown_esExports);
// CONCATENATED MODULE: ./src/components/icons/arrowDown.vue
var arrowDown_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var arrowDown___vue_template_functional__ = false
/* styles */
var arrowDown___vue_styles__ = null
/* scopeId */
var arrowDown___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var arrowDown___vue_module_identifier__ = null
var arrowDown_Component = arrowDown_normalizeComponent(
  arrowDown,
  icons_arrowDown,
  arrowDown___vue_template_functional__,
  arrowDown___vue_styles__,
  arrowDown___vue_scopeId__,
  arrowDown___vue_module_identifier__
)

/* harmony default export */ var components_icons_arrowDown = (arrowDown_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/sort.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sort = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bec8ade","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/sort.vue
var sort_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 320 512"}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{attrs:{"d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"}})])])}
var sort_staticRenderFns = []
var sort_esExports = { render: sort_render, staticRenderFns: sort_staticRenderFns }
/* harmony default export */ var icons_sort = (sort_esExports);
// CONCATENATED MODULE: ./src/components/icons/sort.vue
var sort_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sort___vue_template_functional__ = false
/* styles */
var sort___vue_styles__ = null
/* scopeId */
var sort___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sort___vue_module_identifier__ = null
var sort_Component = sort_normalizeComponent(
  sort,
  icons_sort,
  sort___vue_template_functional__,
  sort___vue_styles__,
  sort___vue_scopeId__,
  sort___vue_module_identifier__
)

/* harmony default export */ var components_icons_sort = (sort_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/sortDown.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sortDown = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96ba368c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/sortDown.vue
var sortDown_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 320 512"}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{attrs:{"d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"}})])])}
var sortDown_staticRenderFns = []
var sortDown_esExports = { render: sortDown_render, staticRenderFns: sortDown_staticRenderFns }
/* harmony default export */ var icons_sortDown = (sortDown_esExports);
// CONCATENATED MODULE: ./src/components/icons/sortDown.vue
var sortDown_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sortDown___vue_template_functional__ = false
/* styles */
var sortDown___vue_styles__ = null
/* scopeId */
var sortDown___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sortDown___vue_module_identifier__ = null
var sortDown_Component = sortDown_normalizeComponent(
  sortDown,
  icons_sortDown,
  sortDown___vue_template_functional__,
  sortDown___vue_styles__,
  sortDown___vue_scopeId__,
  sortDown___vue_module_identifier__
)

/* harmony default export */ var components_icons_sortDown = (sortDown_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/sortUp.vue
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var sortUp = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c3f3842","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/sortUp.vue
var sortUp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 320 512"}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{attrs:{"d":"M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"}})])])}
var sortUp_staticRenderFns = []
var sortUp_esExports = { render: sortUp_render, staticRenderFns: sortUp_staticRenderFns }
/* harmony default export */ var icons_sortUp = (sortUp_esExports);
// CONCATENATED MODULE: ./src/components/icons/sortUp.vue
var sortUp_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sortUp___vue_template_functional__ = false
/* styles */
var sortUp___vue_styles__ = null
/* scopeId */
var sortUp___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sortUp___vue_module_identifier__ = null
var sortUp_Component = sortUp_normalizeComponent(
  sortUp,
  icons_sortUp,
  sortUp___vue_template_functional__,
  sortUp___vue_styles__,
  sortUp___vue_scopeId__,
  sortUp___vue_module_identifier__
)

/* harmony default export */ var components_icons_sortUp = (sortUp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/loader.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loader = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String },
    strokeColor: { type: String },
    strokeWidth: { type: Number }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5add554","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/loader.vue
var loader_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"lds-rolling",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 100 100","preserveAspectRatio":"xMidYMid"}},[_c('g',{attrs:{"fill":_vm.color}},[_vm._v("\n    viewBox%3D'0 0 27 44' path d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23007aff'%2F%3E%3C%2Fsvg%3E\"\n  ")]),_vm._v(" "),_c('circle',{attrs:{"cx":"50","cy":"50","fill":"none","stroke":_vm.strokeColor,"stroke-width":_vm.strokeWidth,"r":"35","stroke-dasharray":"164.93361431346415 56.97787143782138"}},[_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","calcMode":"linear","values":"0 50 50;360 50 50","keyTimes":"0;1","dur":"1s","begin":"0s","repeatCount":"indefinite"}})],1)])}
var loader_staticRenderFns = []
var loader_esExports = { render: loader_render, staticRenderFns: loader_staticRenderFns }
/* harmony default export */ var icons_loader = (loader_esExports);
// CONCATENATED MODULE: ./src/components/icons/loader.vue
function loader_injectStyle (ssrContext) {
  __webpack_require__("XKrC")
}
var loader_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loader___vue_template_functional__ = false
/* styles */
var loader___vue_styles__ = loader_injectStyle
/* scopeId */
var loader___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var loader___vue_module_identifier__ = null
var loader_Component = loader_normalizeComponent(
  loader,
  icons_loader,
  loader___vue_template_functional__,
  loader___vue_styles__,
  loader___vue_scopeId__,
  loader___vue_module_identifier__
)

/* harmony default export */ var components_icons_loader = (loader_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/melodieLogo.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var melodieLogo = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8998c4a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/melodieLogo.vue
var melodieLogo_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 377 43.9"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M49.5,40.9h-7.8V13.5h-0.3l-15,15.4l-15-15.4h-0.3v27.4H3.5V3h11.2l11.8,12.8L38.3,3h11.2V40.9z"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.color,"d":"M108.5,13.5H67.3V9.3L70.7,3h37.8V13.5z M67.3,27.1V16.8h37.9v10.3H67.3z M108.5,30.5v10.4H70.7l-3.4-6.3v-4.1\n    H108.5z"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.color,"d":"M126.3,34.6V3h9.5v27.5h25.7v10.4h-31.7L126.3,34.6z"}}),_vm._v(" "),_c('polygon',{attrs:{"fill":_vm.color,"points":"220.9,3 182.7,3 179.2,9.3 179.2,34.6 182.7,40.9 200.1,40.9 200.1,30.5 187,30.5 187,13.5 216.6,13.5\n    216.6,30.5 203.5,30.5 203.5,40.9 220.9,40.9 224.4,34.6 224.4,9.3 "}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.color,"d":"M279.5,30.5v-17h-37.3V3h41.7l3.4,6.3v25.3l-3.4,6.3h-41.7V17.4h7.8v13.1H279.5z"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.color,"d":"M304.2,3h9.5v37.9h-9.5V3z"}}),_vm._v(" "),_c('path',{attrs:{"fill":_vm.color,"d":"M373.6,13.5h-41.2V9.3l3.4-6.3h37.8V13.5z M332.4,27.1V16.8h37.9v10.3H332.4z M373.6,30.5v10.4h-37.8l-3.4-6.3\n    v-4.1H373.6z"}})])}
var melodieLogo_staticRenderFns = []
var melodieLogo_esExports = { render: melodieLogo_render, staticRenderFns: melodieLogo_staticRenderFns }
/* harmony default export */ var icons_melodieLogo = (melodieLogo_esExports);
// CONCATENATED MODULE: ./src/components/icons/melodieLogo.vue
function melodieLogo_injectStyle (ssrContext) {
  __webpack_require__("ifLO")
}
var melodieLogo_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var melodieLogo___vue_template_functional__ = false
/* styles */
var melodieLogo___vue_styles__ = melodieLogo_injectStyle
/* scopeId */
var melodieLogo___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var melodieLogo___vue_module_identifier__ = null
var melodieLogo_Component = melodieLogo_normalizeComponent(
  melodieLogo,
  icons_melodieLogo,
  melodieLogo___vue_template_functional__,
  melodieLogo___vue_styles__,
  melodieLogo___vue_scopeId__,
  melodieLogo___vue_module_identifier__
)

/* harmony default export */ var components_icons_melodieLogo = (melodieLogo_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/play.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var play = ({
  props: {
    width: { type: String },
    height: { type: String },
    color: { type: String },
    stroke: { type: String }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab46730","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/play.vue
var play_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"play-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 152 152"}},[_c('circle',{staticClass:"play-circle-01",attrs:{"fill":"none","stroke":_vm.color,"stroke-width":_vm.stroke,"stroke-dasharray":"343 343","cx":"76","cy":"76","r":"72.7"}}),_vm._v(" "),_c('circle',{staticClass:"play-circle-02",attrs:{"fill":"none","stroke":_vm.color,"stroke-width":_vm.stroke,"stroke-dasharray":"309 309","cx":"76","cy":"76","r":"65.5"}})])}
var play_staticRenderFns = []
var play_esExports = { render: play_render, staticRenderFns: play_staticRenderFns }
/* harmony default export */ var icons_play = (play_esExports);
// CONCATENATED MODULE: ./src/components/icons/play.vue
var play_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var play___vue_template_functional__ = false
/* styles */
var play___vue_styles__ = null
/* scopeId */
var play___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var play___vue_module_identifier__ = null
var play_Component = play_normalizeComponent(
  play,
  icons_play,
  play___vue_template_functional__,
  play___vue_styles__,
  play___vue_scopeId__,
  play___vue_module_identifier__
)

/* harmony default export */ var components_icons_play = (play_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/icons/UiBaseIcon.vue
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ var UiBaseIcon = ({
  name: 'UiIconBase',
  props: {
    iconName: {
      type: String,
      default: 'moon'
    },
    width: {
      type: String,
      default: '18px'
    },
    height: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    stroke: {
      type: String,
      default: '1px'
    }
  },

  components: {
    write: components_icons_write,
    moon: components_icons_moon,
    play: components_icons_play,
    done: components_icons_done,
    arrowDown: components_icons_arrowDown,
    sort: components_icons_sort,
    sortDown: components_icons_sortDown,
    sortUp: components_icons_sortUp,
    loader: components_icons_loader,
    melodie: components_icons_melodieLogo
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-024f74bf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/UiBaseIcon.vue
var UiBaseIcon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._g({staticClass:"ui-icon-base component"},_vm.$listeners),[_c(_vm.iconName,{tag:"component",attrs:{"width":_vm.width,"height":_vm.height,"color":_vm.color}})],1)}
var UiBaseIcon_staticRenderFns = []
var UiBaseIcon_esExports = { render: UiBaseIcon_render, staticRenderFns: UiBaseIcon_staticRenderFns }
/* harmony default export */ var icons_UiBaseIcon = (UiBaseIcon_esExports);
// CONCATENATED MODULE: ./src/components/icons/UiBaseIcon.vue
function UiBaseIcon_injectStyle (ssrContext) {
  __webpack_require__("Cr0F")
}
var UiBaseIcon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiBaseIcon___vue_template_functional__ = false
/* styles */
var UiBaseIcon___vue_styles__ = UiBaseIcon_injectStyle
/* scopeId */
var UiBaseIcon___vue_scopeId__ = "data-v-024f74bf"
/* moduleIdentifier (server only) */
var UiBaseIcon___vue_module_identifier__ = null
var UiBaseIcon_Component = UiBaseIcon_normalizeComponent(
  UiBaseIcon,
  icons_UiBaseIcon,
  UiBaseIcon___vue_template_functional__,
  UiBaseIcon___vue_styles__,
  UiBaseIcon___vue_scopeId__,
  UiBaseIcon___vue_module_identifier__
)

/* harmony default export */ var components_icons_UiBaseIcon = (UiBaseIcon_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Header = ({
  name: "Header",
  components: {
    UiToastList: src_components_UiToastList,
    UiHeaderDropdownMenu: src_components_UiHeaderDropdownMenu,
    UiBaseIcon: components_icons_UiBaseIcon
  },
  methods: {
    goHome: function goHome() {
      this.$router.push({ name: "index" });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c1969e5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"menu-wrapper"},[_c('div',{staticClass:"logo",on:{"click":_vm.goHome}},[_c('UiBaseIcon',{attrs:{"width":"160px","height":"85px","color":"#404041","iconName":"melodie"}})],1),_vm._v(" "),_c('div',{staticClass:"side-menu-icon"},[_c('ul',{staticClass:"menu"},[_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{ name: 'index' },"exact":""}},[_vm._v("home")])],1),_vm._v(" "),_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{ name: 'intro' }}},[_vm._v("intro")])],1),_vm._v(" "),_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{ name: 'gallery' }}},[_vm._v("gallery")])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('li',{staticClass:"menu-item"},[_c('router-link',{attrs:{"to":{ name: 'contact' }}},[_vm._v("contact")])],1)])])])])}
var Header_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"menu-item"},[_c('a',{attrs:{"href":"https://events.djmelodie.com","target":"blank"}},[_vm._v("events")])])}]
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var layout_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/layout/Header.vue
function Header_injectStyle (ssrContext) {
  __webpack_require__("B6bC")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = "data-v-7c1969e5"
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  layout_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var src_layout_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/Footer.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var Footer = ({
  name: 'Footer',
  components: {
    UiBaseIcon: components_icons_UiBaseIcon
  },
  data: function data() {
    return {
      currentYear: new Date().getFullYear(),
      pages: ['index', 'intro', 'portfolio', 'contact'],
      current: null
    };
  },
  mounted: function mounted() {
    var container = document.querySelector('.footer');
    var footer = document.querySelector('footer').offsetHeight;
    console.log(container);
    console.log(footer);
    container.setAttribute('style', 'height: ' + footer + 'px');
  },

  methods: {
    goToPage: function goToPage(pagename) {
      this.current = pagename;
      this.$router.push({ name: this.current });
    },
    goToNextPage: function goToNextPage() {
      this.$parent.gotoNextScreen();
    }
  },
  computed: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-975fb37a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/Footer.vue
var Footer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Footer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"footer-container"}),_vm._v(" "),_c('footer',[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row between-xs middle-xs"},[_c('div',{staticClass:"email"},[_c('p',[_vm._v("say hi - "),_c('a',{staticClass:"text-bold prime-color",attrs:{"href":"mailto:hello@djmelodie.com"}},[_vm._v("hello@djmelodie.com")])])]),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('p',[_vm._v("Melodie 2018")])])])])])])}]
var Footer_esExports = { render: Footer_render, staticRenderFns: Footer_staticRenderFns }
/* harmony default export */ var layout_Footer = (Footer_esExports);
// CONCATENATED MODULE: ./src/layout/Footer.vue
function Footer_injectStyle (ssrContext) {
  __webpack_require__("ecqj")
}
var Footer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Footer___vue_template_functional__ = false
/* styles */
var Footer___vue_styles__ = Footer_injectStyle
/* scopeId */
var Footer___vue_scopeId__ = "data-v-975fb37a"
/* moduleIdentifier (server only) */
var Footer___vue_module_identifier__ = null
var Footer_Component = Footer_normalizeComponent(
  Footer,
  layout_Footer,
  Footer___vue_template_functional__,
  Footer___vue_styles__,
  Footer___vue_scopeId__,
  Footer___vue_module_identifier__
)

/* harmony default export */ var src_layout_Footer = (Footer_Component.exports);

// EXTERNAL MODULE: ./node_modules/gsap/all.js + 18 modules
var gsap_all = __webpack_require__("QoXc");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiModal = ({
  name: 'UiModal',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    },
    closeOnOverlay: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    close: function close() {
      this.$emit('update:show', false);
    },
    onClickOverlay: function onClickOverlay($event) {
      if (this.closeOnOverlay && $event && $event.target === this.$refs.overlay) {
        this.close();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7799e8ba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiModal.vue
var UiModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"modal"}},[(_vm.show)?_c('div',{ref:"overlay",staticClass:"ui-modal overlay component",on:{"click":_vm.onClickOverlay}},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"header"},[(_vm.showCloseButton)?_c('div',{staticClass:"close",on:{"click":_vm.close}},[_c('div',{staticClass:"close-line left"}),_vm._v(" "),_c('div',{staticClass:"close-line right"})]):_vm._e()]),_vm._v(" "),_vm._t("default")],2)]):_vm._e()])}
var UiModal_staticRenderFns = []
var UiModal_esExports = { render: UiModal_render, staticRenderFns: UiModal_staticRenderFns }
/* harmony default export */ var components_UiModal = (UiModal_esExports);
// CONCATENATED MODULE: ./src/components/UiModal.vue
function UiModal_injectStyle (ssrContext) {
  __webpack_require__("aId2")
}
var UiModal_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiModal___vue_template_functional__ = false
/* styles */
var UiModal___vue_styles__ = UiModal_injectStyle
/* scopeId */
var UiModal___vue_scopeId__ = "data-v-7799e8ba"
/* moduleIdentifier (server only) */
var UiModal___vue_module_identifier__ = null
var UiModal_Component = UiModal_normalizeComponent(
  UiModal,
  components_UiModal,
  UiModal___vue_template_functional__,
  UiModal___vue_styles__,
  UiModal___vue_scopeId__,
  UiModal___vue_module_identifier__
)

/* harmony default export */ var src_components_UiModal = (UiModal_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiInputText.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiInputText = ({
  name: 'UiInputText',

  props: {
    label: { type: String },
    height: { type: String, default: '48px' },
    password: { type: Boolean, default: false },
    value: { required: true },
    placeholder: { type: String },
    error: {
      type: [String, Boolean],
      default: false
    }
  },

  methods: {
    getRandomInt: function getRandomInt() {
      var min = 1;
      var max = 1000000000;
      return Math.floor(Math.random() * (max - min + 1) + min);
    }
  },

  computed: {
    inputHeight: function inputHeight() {
      return 'height: ' + this.height + ';';
    },
    inputClasses: function inputClasses() {
      return {
        'is-input-error': this.error,
        'border-radius-start': !this.$slots.before,
        'border-radius-end': !this.$slots.after
      };
    },
    labelId: function labelId() {
      return 'inputId' + this.getRandomInt();
    },
    inputType: function inputType() {
      return this.password ? 'password' : 'text';
    },
    listeners: function listeners() {
      var _this = this;

      return extends_default()({}, this.$listeners, {
        input: function input(event) {
          return _this.$emit('input', event.target.value);
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0aaa53e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiInputText.vue
var UiInputText_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-input-text component"},[(_vm.$slots.before)?_c('div',{staticClass:"slot-before",style:(_vm.inputHeight)},[_vm._t("before")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-wrapper"},[_c('label',{class:{ 'is-label-error': _vm.error },attrs:{"for":_vm.labelId}},[_vm._v(_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_c('input',_vm._g({class:_vm.inputClasses,style:(_vm.inputHeight),attrs:{"id":_vm.labelId,"type":_vm.inputType,"placeholder":_vm.placeholder},domProps:{"value":_vm.value}},_vm.listeners)),_vm._v(" "),(_vm.$slots.bottom)?_c('div',{staticClass:"slot-bottom"},[_vm._t("bottom")],2):_vm._e()]),_vm._v(" "),(_vm.$slots.after)?_c('div',{staticClass:"slot-after",style:(_vm.inputHeight)},[_vm._t("after")],2):_vm._e()])}
var UiInputText_staticRenderFns = []
var UiInputText_esExports = { render: UiInputText_render, staticRenderFns: UiInputText_staticRenderFns }
/* harmony default export */ var components_UiInputText = (UiInputText_esExports);
// CONCATENATED MODULE: ./src/components/UiInputText.vue
function UiInputText_injectStyle (ssrContext) {
  __webpack_require__("/kTh")
}
var UiInputText_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiInputText___vue_template_functional__ = false
/* styles */
var UiInputText___vue_styles__ = UiInputText_injectStyle
/* scopeId */
var UiInputText___vue_scopeId__ = "data-v-f0aaa53e"
/* moduleIdentifier (server only) */
var UiInputText___vue_module_identifier__ = null
var UiInputText_Component = UiInputText_normalizeComponent(
  UiInputText,
  components_UiInputText,
  UiInputText___vue_template_functional__,
  UiInputText___vue_styles__,
  UiInputText___vue_scopeId__,
  UiInputText___vue_module_identifier__
)

/* harmony default export */ var src_components_UiInputText = (UiInputText_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiCheckbox.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var UiCheckbox = ({
  name: 'UiCheckbox',

  props: {
    checked: { type: Boolean, required: true }, // v-model
    value: { type: [String, Number, Boolean] }
  },

  model: {
    prop: 'checked',
    event: 'change'
  },

  components: {
    UiBaseIcon: components_icons_UiBaseIcon
  },

  methods: {
    getRandomInt: function getRandomInt() {
      var min = 1;
      var max = 1000000000;
      return Math.floor(Math.random() * (max - min + 1) + min);
    }
  },

  computed: {
    labelId: function labelId() {
      return 'inputId' + this.getRandomInt();
    },
    listeners: function listeners() {
      var _this = this;

      return extends_default()({}, this.$listeners, {
        change: function change(event) {
          return _this.$emit('change', event.target.checked);
        }
      });
    }
  }

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a43a28f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiCheckbox.vue
var UiCheckbox_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-checkbox component"},[_c('UiBaseIcon',{staticClass:"ok",attrs:{"width":"8px","iconName":"done"}}),_vm._v(" "),_c('input',_vm._g({attrs:{"id":_vm.labelId,"type":"checkbox"},domProps:{"checked":_vm.checked}},_vm.listeners)),_vm._v(" "),_c('label',{attrs:{"for":_vm.labelId}})],1)}
var UiCheckbox_staticRenderFns = []
var UiCheckbox_esExports = { render: UiCheckbox_render, staticRenderFns: UiCheckbox_staticRenderFns }
/* harmony default export */ var components_UiCheckbox = (UiCheckbox_esExports);
// CONCATENATED MODULE: ./src/components/UiCheckbox.vue
function UiCheckbox_injectStyle (ssrContext) {
  __webpack_require__("8Z9s")
}
var UiCheckbox_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiCheckbox___vue_template_functional__ = false
/* styles */
var UiCheckbox___vue_styles__ = UiCheckbox_injectStyle
/* scopeId */
var UiCheckbox___vue_scopeId__ = "data-v-0a43a28f"
/* moduleIdentifier (server only) */
var UiCheckbox___vue_module_identifier__ = null
var UiCheckbox_Component = UiCheckbox_normalizeComponent(
  UiCheckbox,
  components_UiCheckbox,
  UiCheckbox___vue_template_functional__,
  UiCheckbox___vue_styles__,
  UiCheckbox___vue_scopeId__,
  UiCheckbox___vue_module_identifier__
)

/* harmony default export */ var src_components_UiCheckbox = (UiCheckbox_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiPaginationOffset.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiPaginationOffset = ({
  name: 'UiPaginationOffset',

  props: {
    offset: {
      type: Number,
      default: 0,
      required: true
    },
    total: {
      type: Number,
      default: 0,
      required: true
    },
    limit: {
      type: Number,
      default: 0,
      required: true
    }
  },

  data: function data() {
    return {
      currentOffset: this.offset
    };
  },


  methods: {
    goToNextPage: function goToNextPage() {
      this.currentOffset += this.limit;
      this.$emit('update:offset', this.currentOffset);
    },
    goToPrevPage: function goToPrevPage() {
      this.currentOffset -= this.limit;
      this.$emit('update:offset', this.currentOffset);
    }
  },

  computed: {
    isDisabledNextBtn: function isDisabledNextBtn() {
      var stop = this.total - this.limit;
      return this.currentOffset >= stop;
    },
    isDisabledPrevBtn: function isDisabledPrevBtn() {
      return this.currentOffset < this.limit;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-718b6aad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiPaginationOffset.vue
var UiPaginationOffset_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"ui-pagination-offset component"},[_c('li',[_c('button',{staticClass:"nav-btn previous",attrs:{"disabled":_vm.isDisabledPrevBtn},on:{"click":_vm.goToPrevPage}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_back")])])]),_vm._v(" "),_c('li',[_c('button',{staticClass:"nav-btn next",attrs:{"disabled":_vm.isDisabledNextBtn},on:{"click":_vm.goToNextPage}},[_c('i',{staticClass:"material-icons"},[_vm._v("arrow_forward")])])])])}
var UiPaginationOffset_staticRenderFns = []
var UiPaginationOffset_esExports = { render: UiPaginationOffset_render, staticRenderFns: UiPaginationOffset_staticRenderFns }
/* harmony default export */ var components_UiPaginationOffset = (UiPaginationOffset_esExports);
// CONCATENATED MODULE: ./src/components/UiPaginationOffset.vue
function UiPaginationOffset_injectStyle (ssrContext) {
  __webpack_require__("7XOo")
}
var UiPaginationOffset_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiPaginationOffset___vue_template_functional__ = false
/* styles */
var UiPaginationOffset___vue_styles__ = UiPaginationOffset_injectStyle
/* scopeId */
var UiPaginationOffset___vue_scopeId__ = "data-v-718b6aad"
/* moduleIdentifier (server only) */
var UiPaginationOffset___vue_module_identifier__ = null
var UiPaginationOffset_Component = UiPaginationOffset_normalizeComponent(
  UiPaginationOffset,
  components_UiPaginationOffset,
  UiPaginationOffset___vue_template_functional__,
  UiPaginationOffset___vue_styles__,
  UiPaginationOffset___vue_scopeId__,
  UiPaginationOffset___vue_module_identifier__
)

/* harmony default export */ var src_components_UiPaginationOffset = (UiPaginationOffset_Component.exports);

// EXTERNAL MODULE: ./node_modules/swiper/dist/css/swiper.css
var swiper = __webpack_require__("v2ns");
var swiper_default = /*#__PURE__*/__webpack_require__.n(swiper);

// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("7QTg");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Home = ({
  name: 'IndexPage',

  components: {
    UiModal: src_components_UiModal,
    UiBaseIcon: components_icons_UiBaseIcon,
    UiInputText: src_components_UiInputText,
    UiCheckbox: src_components_UiCheckbox,
    UiPaginationOffset: src_components_UiPaginationOffset,
    swiper: vue_awesome_swiper["swiper"],
    swiperSlide: vue_awesome_swiper["swiperSlide"]
  },

  data: function data() {
    return {
      title: null,
      headline: null,
      bgTxt: null,
      isShownModal: false,
      inputError: false,
      checkboxState: false,

      pagination: {
        limit: 20,
        offset: 0,
        total: 60
      },

      swiperOption: {
        loop: true,
        centerSlides: true,
        grabCursor: true,
        watchSlidesProgress: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    };
  },


  methods: {
    showToast: function showToast() {
      console.log('aaa');
      this.$store.commit('toast/NEW', { type: 'success', message: 'hello' });
    },
    submitModalHandler: function submitModalHandler() {
      // some logic
      this.isShownModal = false;
    },
    onBlur: function onBlur() {
      console.log('onBlur!!!');
    },
    onEnter: function onEnter() {
      console.log('onEnter!!!');
    },
    onEsc: function onEsc() {
      console.log('onEsc!!!');
    },
    onClickIcon: function onClickIcon() {
      console.log('onClickIcon!!!!');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-556e6c7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Home.vue
var Home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home page",attrs:{"data-page":"1"}},[_c('section',{staticClass:"hero-content fill-height"},[_c('swiper',{staticClass:"swipe-container",attrs:{"option":_vm.swiperOption}},[_c('swiper-slide',[_c('div',{staticClass:"page-media"},[_c('vue-plyr',{staticClass:"embed-container"},[_c('div',{staticClass:"plyr__video-embed"},[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/DAwJ0JAMIt0","allow":"autoplay","allowfullscreen":"","allowtransparency":""}})])])],1)]),_vm._v(" "),_c('swiper-slide',[_c('div',{staticClass:"page-media"},[_c('vue-plyr',{staticClass:"embed-container"},[_c('div',{staticClass:"plyr__video-embed"},[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/DAwJ0JAMIt0","allow":"autoplay","allowfullscreen":"","allowtransparency":""}})])])],1)]),_vm._v(" "),_c('div',{staticClass:"swiper-pagination"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-next"}),_vm._v(" "),_c('div',{staticClass:"swiper-button-prev"})],1)],1)])}
var Home_staticRenderFns = []
var Home_esExports = { render: Home_render, staticRenderFns: Home_staticRenderFns }
/* harmony default export */ var pages_Home = (Home_esExports);
// CONCATENATED MODULE: ./src/pages/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("d7EU")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-556e6c7a"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  pages_Home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var src_pages_Home = (Home_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Intro.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ var Intro = ({
  name: 'IntroPage',

  components: {
    UiModal: src_components_UiModal,
    UiBaseIcon: components_icons_UiBaseIcon,
    UiInputText: src_components_UiInputText,
    UiCheckbox: src_components_UiCheckbox,
    UiPaginationOffset: src_components_UiPaginationOffset
  },

  data: function data() {
    return {
      title: 'About Melodie',
      headline: 'Melodie something'
    };
  },
  created: function created() {
    // this.animateIn();
  },

  methods: {
    // animateIn() {
    //   let title = document.querySelector('.page-title');
    //   let headline = document.querySelector('.page-headline');
    //   let text = document.querySelector('.page-text');
    //   let media = document.querySelector('.page-media');
    //   // let bgColor = screen.getAttribute('data-bg-color');
    //   // let bg = screen.querySelector('.slide-bg');
    //   // bg.style.backgroundColor = bgColor;
    //   let timeLineIn = (new TimelineMax()
    //     .add(this.addTitle(title), 'start')
    //     .add(this.addHeadline(headline), 'start+=.3')
    //     .add(this.addText(text),'start+=.4'))
    //     .add(this.addMedia(media), 'start +=.5');
    //
    // },
    // addMedia(screen) {
    //   let tl = new TimelineMax();
    //   tl.fromTo(screen, 1, {
    //     autoAlpha: 0,
    //     x: '+100%'
    //   }, {
    //     autoAlpha: 1,
    //     x: '0%',
    //     ease: Power3.easeOut
    //   });
    //   return tl;
    // },
    // addText(screen) {
    //   let tl = new TimelineMax();
    //   tl.fromTo(screen, 1, {
    //     y: '-50%',
    //     opacity: 0,
    //   }, {
    //     y: '0%',
    //     opacity: 1,
    //     ease: Power3.easeOut,
    //   });
    //   return tl;
    // },
    // addTitle(screen) {
    //   let tl = new TimelineMax();
    //   tl.fromTo(screen, 1, {
    //     y: '-50%',
    //     opacity: 0,
    //   }, {
    //     y: '0%',
    //     opacity: 1,
    //     ease: Power3.easeOut,
    //   });
    //   return tl;
    // },
    // addHeadline(screen) {
    //   let tl = new TimelineMax();
    //   tl.fromTo(screen, 1, {
    //     y: '-50%',
    //     opacity: 0,
    //   }, {
    //     y: '0%',
    //     opacity: 1,
    //     ease: Power3.easeOut,
    //   });
    //   return tl;
    // },
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce09738","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Intro.vue
var Intro_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var Intro_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intro page",attrs:{"data-page":"2"}},[_c('section',{staticClass:"hero three-quarter-height"}),_vm._v(" "),_c('section',{staticClass:"page-text row"},[_c('div',{staticClass:"hello"},[_vm._v("Hello!")]),_vm._v(" "),_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"text-wrapper intro-body-text"},[_c('h6',{staticClass:"lh-t"},[_vm._v("There are only a very few artist who have the incredible ability to move and please a crowd and bring an emotional response.  Melodie is loved for her music as much as for her personality and she is out to conquer the world with her catchy & melodic tunes.")]),_vm._v(" "),_c('p',[_vm._v("Melodie, a well renowned international DJ & Producer has brought her sounds to the dance floors of legendary venues like “1015” San Francisco, “Ruby Skye” San Francisco, “Air 360 Sky Lounge” Ho Chi Minh City, just to name a few.  Her name appeared in line-up with famous Artist such as Paul Van Dyk, John Fleming, Dj Shogun, Protoculture, Orjan Nilsen, Kristina Sky, Aruna, Betsie Larkin, and many more.")]),_vm._v(" "),_c('p',[_vm._v("To many, Dj Melodie is more than a deejay/producer but an entertainer.  Fans are amazed and moved by her refreshing and unique style of mixing, remix and track selections. She mixes quality tracks that both excite existing fans and bring new people to the ever-changing scene. She gives off a vibe that truly depicts her emotions and love to please the crowd.  Her passion for music is clearly shown and she wants her fans to feel the same appreciation & love she has for it.  Some of the best DJs in the world are known for their skills, ability to read crowd, track selection, and performance.  It should be no surprise that Dj Melodie has all this and more.  Not only she technically skilled and a master of track selection, she has the ability to maintain ultimate control of the audience and can make them feel the music.  She connects with them and takes them on a journey into a beautiful and memorable experience.")]),_c('p',[_vm._v("Over the years, she has been producing, mixing, and has created a multitude of legendary mixes, remixes and songs. For Melodie, music is universal and often combines different genre such as House, Techno, and Trance together in her sets and blends them perfectly.  Her goal and dream is to create a universal sound by combining classical sounds with modern day electronic element and style.")]),_vm._v(" "),_c('p',[_vm._v("Her unique style brought her popularity across the world. Dj Melodie has always been known for getting close to her fans, as reflected by the numbers on her social media sites – in excess of eighty eight thousand followers worldwide! Her fans show their appreciation of this open exchange with their favourite artist by voting her into #27 for the Top & Best 100 Female in the world on TheFDJlist.  In 2017, she is ranking #18 in United States for Djs Top 100 Djanetop.   In the upcoming year, be on the lookout for exciting new songs; remixes, mix compilation and appearances from this DJ!")]),_vm._v(" "),_c('p',[_vm._v("“Nothing let’s me express myself better than music.  Through my work and mixes, I express Love.  That’s who I am. My goal is to bring love, joy and happiness into the hearts of everyone listening.” Says Dj Melodie. ")])])])])])}]
var Intro_esExports = { render: Intro_render, staticRenderFns: Intro_staticRenderFns }
/* harmony default export */ var pages_Intro = (Intro_esExports);
// CONCATENATED MODULE: ./src/pages/Intro.vue
function Intro_injectStyle (ssrContext) {
  __webpack_require__("TlMV")
}
var Intro_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Intro___vue_template_functional__ = false
/* styles */
var Intro___vue_styles__ = Intro_injectStyle
/* scopeId */
var Intro___vue_scopeId__ = "data-v-5ce09738"
/* moduleIdentifier (server only) */
var Intro___vue_module_identifier__ = null
var Intro_Component = Intro_normalizeComponent(
  Intro,
  pages_Intro,
  Intro___vue_template_functional__,
  Intro___vue_styles__,
  Intro___vue_scopeId__,
  Intro___vue_module_identifier__
)

/* harmony default export */ var src_pages_Intro = (Intro_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/get-iterator.js
var get_iterator = __webpack_require__("BO1k");
var get_iterator_default = /*#__PURE__*/__webpack_require__.n(get_iterator);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./node_modules/vue-recaptcha/dist/vue-recaptcha.es.js
var vue_recaptcha_es = __webpack_require__("olAn");

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/validators/index.js
var validators = __webpack_require__("+cKO");
var validators_default = /*#__PURE__*/__webpack_require__.n(validators);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PulseLoading.vue
//
//
//
//
//
//

/* harmony default export */ var PulseLoading = ({
  name: 'PulseLoading'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e0cfae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PulseLoading.vue
var PulseLoading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var PulseLoading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pulse-loading component"},[_c('div',{staticClass:"sk-spinner sk-spinner-pulse"})])}]
var PulseLoading_esExports = { render: PulseLoading_render, staticRenderFns: PulseLoading_staticRenderFns }
/* harmony default export */ var components_PulseLoading = (PulseLoading_esExports);
// CONCATENATED MODULE: ./src/components/PulseLoading.vue
function PulseLoading_injectStyle (ssrContext) {
  __webpack_require__("v+3r")
}
var PulseLoading_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var PulseLoading___vue_template_functional__ = false
/* styles */
var PulseLoading___vue_styles__ = PulseLoading_injectStyle
/* scopeId */
var PulseLoading___vue_scopeId__ = "data-v-51e0cfae"
/* moduleIdentifier (server only) */
var PulseLoading___vue_module_identifier__ = null
var PulseLoading_Component = PulseLoading_normalizeComponent(
  PulseLoading,
  components_PulseLoading,
  PulseLoading___vue_template_functional__,
  PulseLoading___vue_styles__,
  PulseLoading___vue_scopeId__,
  PulseLoading___vue_module_identifier__
)

/* harmony default export */ var src_components_PulseLoading = (PulseLoading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiContactForm.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var UiContactForm = ({
  name: 'UiContactForm',

  props: {
    iconClass: String
  },

  components: {
    VueRecaptcha: vue_recaptcha_es["a" /* default */],
    PulseLoading: src_components_PulseLoading
  },

  data: function data() {
    return {
      title: '',
      content: '',

      contactData: {
        name: '',
        email: '',
        message: '',
        recaptcha: ''
      },

      error: {
        invalidFields: 'Following fields have an invalid or a missing value:',
        general: 'An error happened during submit',
        generalMessage: 'Form sending failed due to technical problems. Please try again later.',
        fieldRequired: '{field} is required',
        fieldInvalid: '{field} is invalid or missing'
      },

      isSubmitted: false,
      submitting: false,
      isError: false,
      errorHeader: 'error.invalidFields',
      errors: [],

      responseMessage: null,
      responseStatus: null,
      errorMessage: null,
      loading: false,
      googleRecaptchaApiKey: '6LfpPmgUAAAAACAQAStx2R6j8el0PGce9ATs-AZk',
      url: 'https://script.google.com/macros/s/AKfycbwIuBw_Cef2uLzX_Y7de5_grnzZ5GRysSOMQQMFsg/exec',
      testUrl: 'http://www.mocky.io/v2/5b6a708b3200001000372eca',
      newurl: 'https://script.google.com/macros/s/AKfycbwIuBw_Cef2uLzX_Y7de5_grnzZ5GRysSOMQQMFsg/exec'
    };
  },


  validations: {
    contactData: {
      name: { required: validators["required"] },
      email: { required: validators["required"], email: validators["email"] },
      message: { required: validators["required"] }
    }
  },

  watch: {
    error: function error() {
      this.isError = this.errors.length > 0;
    }
  },

  mounted: function mounted() {
    // const url = '/static/forms/email.html';
    // this.load(url);
    // this.createFormComponents();
  },

  //
  // beforeUpdate() {
  //   this.destroyFormComponents();
  // },
  //
  // updated() {
  //   this.createFormComponents();
  // },
  //
  // beforeDestroy() {
  //   this.destroyFormComponents();
  // },

  methods: {
    submit: function submit() {
      this.$v.$touch();
      if (!this.$v.$error) {
        this.sendFormData();
      } else {
        this.validationError();
      }
    },
    sendFormData: function sendFormData() {
      var _this = this;

      this.enableSubmitLoader();
      var encoded = '';
      for (var i in this.contactData) {
        encoded = encoded + encodeURIComponent(i) + "=" + encodeURIComponent(this.contactData[i]) + "&";
      }

      axios_default.a.post(this.url, encoded, {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      }).then(function (response) {
        console.log(response);
        _this.submitSuccess(response);
        _this.disableSubmitLoader();
      }).catch(function (error) {
        _this.submitError(error);
        _this.disableSubmitLoader();
        console.log(error);
      });
    },
    submitSuccess: function submitSuccess(response) {
      if (response.data.status === 200) {
        this.isSubmitted = true;
        this.isError = false;
        console.log(response.data);
      } else {
        this.errorHeader = this.error.invalidFields;
        this.errors = response.data.errors;
        this.isError = true;
      }
    },
    submitError: function submitError(error) {
      this.errorHeader = this.error.general;
      this.errors = [{ field: null, message: this.error.generalMessage }];
      this.isError = true;
      console.log(error);
    },
    validationError: function validationError() {
      this.errorHeader = this.error.invalidFields;
      this.errors = this.getErrors();
      this.isError = true;
    },
    getErrors: function getErrors() {
      var errors = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = get_iterator_default()(keys_default()(this.contactData)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var field = _step.value;

          try {
            if (this.getValidationField(field).$error) {
              errors.push({ 'field': field, 'message': null });
            }
          } catch (error) {}
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return errors;
    },
    isErrorField: function isErrorField(field) {
      try {
        if (this.getValidationField(field).$error) {
          return true;
        }
      } catch (error) {}

      return this.errors.some(function (el) {
        return el.field === field;
      });
    },
    getValidationField: function getValidationField(field) {
      if (this.$v.contactData[field]) {
        return this.$v.contactData[field];
      }
      throw Error('No validation for field' + field);
    },
    getFieldClasses: function getFieldClasses(field) {
      return { 'is-invalid': this.isErrorField(field) };
    },
    getIconClasses: function getIconClasses(field) {
      return {
        'cross': this.isErrorField(field)
      };
    },
    onFieldBlur: function onFieldBlur(field) {
      try {
        this.getValidationField(field).$touch();
        if (this.getValidationField(field).$error) {
          if (!this.errors.some(function (el) {
            return el.field === field;
          })) {
            this.errors.push({ 'field': field, 'message': null });
          } else {
            this.errors = this.errors.filter(function (el) {
              return el.field !== field;
            });
          }
        }
      } catch (error) {}
    },
    enableSubmitLoader: function enableSubmitLoader() {
      this.submitting = true;
    },
    disableSubmitLoader: function disableSubmitLoader() {
      this.submitting = false;
    },
    reload: function reload() {
      window.location = '';
    },


    // sendForm() {
    //   let self = this;
    //
    //   this.$validator.validateAll().then(resultOK => {
    //     if(resultOK) {
    //       self.loading = true;
    //       let formData = new FormData();
    //       formData.append('email', this.contactData.email);
    //       formData.append('name', this.contactData.name);
    //       formData.append('message', this.contactData.message);
    //       // let formData = self.toFormData(self.contactData);
    //       axios.post("/email.php", formData, {
    //         headers: {'X-Requested-With': 'XMLHttpRequest'}
    //       }).then((response) => {
    //         self.responseMessage = response.data.message;
    //         self.responseStatus = response.data.status;
    //         self.loading = false;
    //
    //         console.log(self.responseMessage);
    //         console.log(self.responseStatus);
    //       }).catch( e => {
    //         console.log(e);
    //       });
    //     } else {
    //       self.errorMessage = "Please fill all the required fields and check the Captcha";
    //     }
    //   })
    // },
    //
    // toFormData(obj) {
    //   const formData = new FormData();
    //   for (const key in obj) {
    //     // let name = JSON.stringify(key);
    //     // let value = JSON.stringify(obj[key]);
    //     // console.log(name);
    //     // console.log(value);
    //     formData.append(key, obj[key]);
    //   }
    //   console.log(formData.get('name'));
    // },
    //
    // getMessageClass: function () {
    //   return {
    //     'alert-success': this.responseStatus,
    //     'alert-error': !this.responseStatus
    //   }
    // },
    //
    // onVerify: function(response) {
    //   this.contactData.recaptcha = response;
    // },

    // handleClick(e) {
    //   if ( e.target.tagName === 'INPUT' && e.target.type === 'submit' ) {
    //     let data = formSerialize( e.target.form, {
    //       hash: false,
    //       empty: true,
    //     });
    //
    //     data += '&' + e.target.name + '=' + encodeURIComponent( e.target.value );
    //
    //     axios.post(url, data, {
    //       headers: "'X-Requested-With': 'XMLHttpRequest'"
    //     }).then( response => {
    //       this.title = response.data.title;
    //       this.content = response.data.content;
    //       this.components = response.data.components;
    //     });
    //
    //     e.preventDefault();
    //   }
    // },

    keyDown: function keyDown(e) {
      if (e.keyCode == 38 || e.keyCode == 40) {
        // up and down keys
        if (!this.open) {
          this.open = true;
        } else {
          var items = this.$refs.menu.querySelectorAll('li a');
          if (items.length > 0) {
            var index = Array.prototype.indexOf.call(items, e.target);
            if (e.keyCode == 38 && index > 0) index--;else if (e.keyCode == 40 && index < items.length - 1) index++;
            if (index < 0) index = 0;
            items[index].focus();
          }
        }
        e.preventDefault();
      } else if (e.keyCode == 27) {
        // Esc key
        this.$refs.button.focus();
        this.close();
      }
    }
  },

  computed: {
    isFormValid: function isFormValid() {
      var _this2 = this;

      return !keys_default()(this.fields).some(function (key) {
        return _this2.fields[key].invalid;
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243fa9b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiContactForm.vue
var UiContactForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-contact-form component"},[(!_vm.isSubmitted)?_c('form',{staticClass:"form-row gform",attrs:{"data-email":"mail@testing.kaleidoscopesf.us","method":"POST","action":_vm.url,"novalidate":""},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_c('fieldset',{staticClass:"line-input"},[_c('div',{staticClass:"icon",class:_vm.getIconClasses('name')},[_vm._m(0)]),_vm._v(" "),(!_vm.isErrorField('name'))?_c('label',{attrs:{"for":"name"}},[_vm._v(_vm._s(_vm.$t('form.name')))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy.trim",value:(_vm.contactData.name),expression:"contactData.name",modifiers:{"lazy":true,"trim":true}}],staticClass:"form-control",class:_vm.getFieldClasses('name'),attrs:{"id":"name","name":"name","type":"text"},domProps:{"value":(_vm.contactData.name)},on:{"blur":[function($event){return _vm.onFieldBlur('name')},function($event){return _vm.$forceUpdate()}],"change":function($event){_vm.$set(_vm.contactData, "name", $event.target.value.trim())}}}),_vm._v(" "),(_vm.isErrorField('name'))?_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.$t('error.fieldRequired', { field: _vm.$t('form.name') })))]):_vm._e()]),_vm._v(" "),_c('fieldset',{staticClass:"line-input"},[_c('div',{staticClass:"icon",class:_vm.getIconClasses('email')},[_vm._m(1)]),_vm._v(" "),(!_vm.isErrorField('email'))?_c('label',{attrs:{"for":"email"}},[_vm._v(_vm._s(_vm.$t('form.email')))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.lazy.trim",value:(_vm.contactData.email),expression:"contactData.email",modifiers:{"lazy":true,"trim":true}}],staticClass:"form-control",class:_vm.getFieldClasses('email'),attrs:{"id":"email","name":"email","type":"text"},domProps:{"value":(_vm.contactData.email)},on:{"blur":[function($event){return _vm.onFieldBlur('email')},function($event){return _vm.$forceUpdate()}],"change":function($event){_vm.$set(_vm.contactData, "email", $event.target.value.trim())}}}),_vm._v(" "),(_vm.isErrorField('email'))?_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.$t('error.fieldRequired', { field: _vm.$t('form.email') })))]):_vm._e()]),_vm._v(" "),_c('fieldset',{staticClass:"line-input"},[(!_vm.isErrorField('message'))?_c('label',{attrs:{"for":"message"}},[_vm._v(_vm._s(_vm.$t('form.message')))]):_vm._e(),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.contactData.message),expression:"contactData.message"}],staticClass:"form-control",class:_vm.getFieldClasses('message'),attrs:{"id":"message","name":"message","rows":"3"},domProps:{"value":(_vm.contactData.message)},on:{"blur":function($event){return _vm.onFieldBlur('message')},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.contactData, "message", $event.target.value)}}}),_vm._v(" "),(_vm.isErrorField('message'))?_c('div',{staticClass:"error-msg"},[_vm._v(_vm._s(_vm.$t('error.fieldRequired', { field: _vm.$t('form.message') })))]):_vm._e()]),_vm._v(" "),_c('fieldset',{staticClass:"line-input"},[_c('button',{staticClass:"btn btn-submit",attrs:{"type":"submit","disabled":_vm.submitting}},[(_vm.submitting)?_c('span',[_c('PulseLoading')],1):_c('span',[_vm._v(_vm._s(_vm.$t('form.submit' )))])])])]):_vm._e(),_vm._v(" "),(_vm.isSubmitted)?_c('div',[_c('div',{staticClass:"alert alert-success"},[_c('strong',[_vm._v(_vm._s(_vm.$t('form.submitted' )))])]),_vm._v(" "),_c('div',{staticClass:"alert alert-info"},[_c('p',[_c('strong',[_vm._v(_vm._s(_vm.$t('form.sentInfo' )))])]),_vm._v(" "),_c('pre',[_vm._v("          "+_vm._s(_vm.contactData)+"\n      ")])]),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('a',{staticClass:"btn btn-secondary",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.reload()}}},[_vm._v(_vm._s(_vm.$t('form.return' )))])])]):_vm._e()])}
var UiContactForm_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"s1"}),_vm._v(" "),_c('span',{staticClass:"s2"}),_vm._v(" "),_c('span',{staticClass:"s3"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"s1"}),_vm._v(" "),_c('span',{staticClass:"s2"}),_vm._v(" "),_c('span',{staticClass:"s3"})])}]
var UiContactForm_esExports = { render: UiContactForm_render, staticRenderFns: UiContactForm_staticRenderFns }
/* harmony default export */ var components_UiContactForm = (UiContactForm_esExports);
// CONCATENATED MODULE: ./src/components/UiContactForm.vue
function UiContactForm_injectStyle (ssrContext) {
  __webpack_require__("6JGP")
}
var UiContactForm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiContactForm___vue_template_functional__ = false
/* styles */
var UiContactForm___vue_styles__ = UiContactForm_injectStyle
/* scopeId */
var UiContactForm___vue_scopeId__ = "data-v-243fa9b2"
/* moduleIdentifier (server only) */
var UiContactForm___vue_module_identifier__ = null
var UiContactForm_Component = UiContactForm_normalizeComponent(
  UiContactForm,
  components_UiContactForm,
  UiContactForm___vue_template_functional__,
  UiContactForm___vue_styles__,
  UiContactForm___vue_scopeId__,
  UiContactForm___vue_module_identifier__
)

/* harmony default export */ var src_components_UiContactForm = (UiContactForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Contact.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var Contact = ({
  name: 'ContactPage',

  components: {
    UiModal: src_components_UiModal,
    UiBaseIcon: components_icons_UiBaseIcon,
    UiInputText: src_components_UiInputText,
    UiContactForm: src_components_UiContactForm
  },

  data: function data() {
    var _ref;

    return _ref = {
      title: 'Contact',
      headline: 'Give us a shout for a free quote within 24 hours',
      bgTxt: 'COPE',

      formTitle: '',
      formContent: '',
      formComponents: null,

      key: 'AIzaSyDvZkJF4xYQPWnF_-Gg2ihTuic9GuH8ukk'
    }, defineProperty_default()(_ref, 'title', 'location'), defineProperty_default()(_ref, 'map', {
      disableDefaultUI: true,
      draggable: false,
      center: {
        lat: 37.3627041,
        lng: -122.0484772
      }
    }), defineProperty_default()(_ref, 'mapTypeId', 'roadmap'), defineProperty_default()(_ref, 'marker', {
      position: {
        lat: 37.3627041,
        lng: -122.0484772
      },
      label: "ColorBloq",
      icon: {
        labelOrigin: {
          x: 0,
          y: 0
        },
        url: '/static/map-marker.png',
        size: {
          width: 80,
          height: 80
        },
        shape: {
          cords: [1, 1, 1, 10, 18, 21, 18, 1],
          type: 'poly'
        }
      },
      title: 'ColorBloq'
    }), defineProperty_default()(_ref, 'mapStyle', [{
      "featureType": "administrative",
      "elementType": "all",
      "stylers": [{
        "hue": "#82B1FF"
      }, {
        "saturation": 7
      }, {
        "lightness": 19
      }]
    }, {
      "featureType": "administrative.province",
      "elementType": "all",
      "stylers": [{
        "visibility": "off"
      }]
    }, {
      "featureType": "landscape",
      "elementType": "all",
      "stylers": [{
        "saturation": -100
      }, {
        "lightness": 40
      }, {
        "visibility": "simplified"
      }]
    }, {
      "featureType": "poi",
      "elementType": "all",
      "stylers": [{
        "hue": "#ffffff"
      }, {
        "saturation": -100
      }, {
        "lightness": 100
      }, {
        "visibility": "off"
      }]
    }, {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [{
        "saturation": "-100"
      }, {
        "lightness": 31
      }, {
        "visibility": "simplified"
      }]
    }, {
      "featureType": "road",
      "elementType": "labels",
      "stylers": [{
        "hue": "#bbc0c4"
      }, {
        "saturation": -93
      }, {
        "lightness": 31
      }, {
        "visibility": "on"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "all",
      "stylers": [{
        "visibility": "simplified"
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [{
        "color": "#ffffff"
      }, {
        "lightness": 17
      }]
    }, {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [{
        "color": "#ffffff"
      }, {
        "lightness": 29
      }, {
        "weight": .2
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [{
        "lightness": "16"
      }, {
        "color": "#ffffff"
      }]
    }, {
      "featureType": "road.local",
      "elementType": "geometry",
      "stylers": [{
        "hue": "#e9ebed"
      }, {
        "saturation": -90
      }, {
        "lightness": -8
      }, {
        "visibility": "simplified"
      }]
    }, {
      "featureType": "road.arterial",
      "elementType": "labels",
      "stylers": [{
        "hue": "#bbc0c4"
      }, {
        "saturation": -93
      }, {
        "lightness": -2
      }, {
        "visibility": "simplified"
      }]
    }, {
      "featureType": "transit",
      "elementType": "all",
      "stylers": [{
        "saturation": -100
      }, {
        "visibility": "simplified"
      }]
    }, {
      "featureType": "water",
      "elementType": "all",
      "stylers": [{
        "hue": "#eef5fd"
      }, {
        "saturation": -58
      }, {
        "lightness": 30
      }, {
        "visibility": "simplified"
      }]
    }, {
      "featureType": "water",
      "elementType": "labels",
      "stylers": [{
        "lightness": -25
      }, {
        "saturation": -100
      }]
    }, {
      "elementType": "labels.text.fill",
      "stylers": [{
        "color": "#adcef6"
      }]
    }]), _ref;
  },


  methods: {}

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b94803d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Contact.vue
var Contact_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact page",attrs:{"data-page":"4"}},[_c('section',{staticClass:"hero-content three-quarter-height"},[_c('gmap-map',{staticStyle:{"width":"100%","height":"100%"},attrs:{"center":_vm.map.center,"zoom":11,"map-type-id":_vm.mapTypeId,"options":{
        styles: _vm.mapStyle,
        disableDefaultUI: _vm.map.disableDefaultUI,
        draggable: _vm.map.draggable,
        center: _vm.map.center }}},[_c('gmap-marker',{attrs:{"position":_vm.marker.position,"draggable":false,"clickable":true,"icon":_vm.marker.icon,"title":_vm.marker.title},on:{"click":_vm.infoPopup}})],1)],1),_vm._v(" "),_c('section',{staticClass:"page-text"},[_c('div',{},[_c('div',{staticClass:"text-wrapper contact-form"},[_c('h3',{staticClass:"headline"},[_vm._v("Let Melodie know what you have in mind")]),_vm._v(" "),_c('UiContactForm')],1)])])])}
var Contact_staticRenderFns = []
var Contact_esExports = { render: Contact_render, staticRenderFns: Contact_staticRenderFns }
/* harmony default export */ var pages_Contact = (Contact_esExports);
// CONCATENATED MODULE: ./src/pages/Contact.vue
function Contact_injectStyle (ssrContext) {
  __webpack_require__("fDp4")
}
var Contact_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Contact___vue_template_functional__ = false
/* styles */
var Contact___vue_styles__ = Contact_injectStyle
/* scopeId */
var Contact___vue_scopeId__ = "data-v-b94803d0"
/* moduleIdentifier (server only) */
var Contact___vue_module_identifier__ = null
var Contact_Component = Contact_normalizeComponent(
  Contact,
  pages_Contact,
  Contact___vue_template_functional__,
  Contact___vue_styles__,
  Contact___vue_scopeId__,
  Contact___vue_module_identifier__
)

/* harmony default export */ var src_pages_Contact = (Contact_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiCardMedia.vue

//
//
//
//
//
//
//
//
//

/* harmony default export */ var UiCardMedia = ({
  functional: true,

  name: 'UiCardMedia',

  props: {
    alt: String,
    media: {
      type: [String, Object],
      default: ''
    },
    position: {
      type: String,
      default: 'center center'
    },
    transition: {
      type: String,
      default: 'fade-transition'
    }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    var staticClass = 'card-media';
    data.staticClass = data.staticClass ? '' + data.staticClass : staticClass;
    data.style = data.style || {};
    data.style['background-image'] = data.style['background-image'] || 'url(' + props.media + ')';
    data.style['background-position'] = data.style['background-position'] || 'center center';
    data.style['background-size'] = data.style['background-size'] || 'cover';

    return h('section', extends_default()({}, data), children);
  }
});
// CONCATENATED MODULE: ./src/components/UiCardMedia.vue
var UiCardMedia_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var UiCardMedia___vue_template__ = null
/* template functional */
var UiCardMedia___vue_template_functional__ = false
/* styles */
var UiCardMedia___vue_styles__ = null
/* scopeId */
var UiCardMedia___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UiCardMedia___vue_module_identifier__ = null
var UiCardMedia_Component = UiCardMedia_normalizeComponent(
  UiCardMedia,
  UiCardMedia___vue_template__,
  UiCardMedia___vue_template_functional__,
  UiCardMedia___vue_styles__,
  UiCardMedia___vue_scopeId__,
  UiCardMedia___vue_module_identifier__
)

/* harmony default export */ var components_UiCardMedia = (UiCardMedia_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiCardTitle.vue


/* harmony default export */ var UiCardTitle = ({
  functional: true,

  name: 'UiCardTitle',

  props: {
    large: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props,
        parent = _ref.parent;

    var staticClass = 'card-title';
    data.staticClass = data.staticClass ? data.staticClass + ' ' + staticClass : staticClass;

    return h('h1', extends_default()({}, data), children);
  }
});
// CONCATENATED MODULE: ./src/components/UiCardTitle.vue
var UiCardTitle_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var UiCardTitle___vue_template__ = null
/* template functional */
var UiCardTitle___vue_template_functional__ = false
/* styles */
var UiCardTitle___vue_styles__ = null
/* scopeId */
var UiCardTitle___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UiCardTitle___vue_module_identifier__ = null
var UiCardTitle_Component = UiCardTitle_normalizeComponent(
  UiCardTitle,
  UiCardTitle___vue_template__,
  UiCardTitle___vue_template_functional__,
  UiCardTitle___vue_styles__,
  UiCardTitle___vue_scopeId__,
  UiCardTitle___vue_module_identifier__
)

/* harmony default export */ var components_UiCardTitle = (UiCardTitle_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiCardSubtitle.vue


/* harmony default export */ var UiCardSubtitle = ({
  functional: true,

  name: 'UiCardSubtitle',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    var staticClass = 'card-subtitle';
    data.staticClass = data.staticClass ? data.staticClass + ' ' + staticClass : staticClass;

    return h('h3', extends_default()({}, data), children);
  }
});
// CONCATENATED MODULE: ./src/components/UiCardSubtitle.vue
var UiCardSubtitle_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var UiCardSubtitle___vue_template__ = null
/* template functional */
var UiCardSubtitle___vue_template_functional__ = false
/* styles */
var UiCardSubtitle___vue_styles__ = null
/* scopeId */
var UiCardSubtitle___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UiCardSubtitle___vue_module_identifier__ = null
var UiCardSubtitle_Component = UiCardSubtitle_normalizeComponent(
  UiCardSubtitle,
  UiCardSubtitle___vue_template__,
  UiCardSubtitle___vue_template_functional__,
  UiCardSubtitle___vue_styles__,
  UiCardSubtitle___vue_scopeId__,
  UiCardSubtitle___vue_module_identifier__
)

/* harmony default export */ var components_UiCardSubtitle = (UiCardSubtitle_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiCardBodyText.vue


/* harmony default export */ var UiCardBodyText = ({
  functional: true,

  name: 'cardBodyText',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    var staticClass = 'card-body-text';
    data.staticClass = data.staticClass ? data.staticClass + ' ' + staticClass : staticClass;

    return h('section', extends_default()({}, data), children);
  }
});
// CONCATENATED MODULE: ./src/components/UiCardBodyText.vue
var UiCardBodyText_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var UiCardBodyText___vue_template__ = null
/* template functional */
var UiCardBodyText___vue_template_functional__ = false
/* styles */
var UiCardBodyText___vue_styles__ = null
/* scopeId */
var UiCardBodyText___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UiCardBodyText___vue_module_identifier__ = null
var UiCardBodyText_Component = UiCardBodyText_normalizeComponent(
  UiCardBodyText,
  UiCardBodyText___vue_template__,
  UiCardBodyText___vue_template_functional__,
  UiCardBodyText___vue_styles__,
  UiCardBodyText___vue_scopeId__,
  UiCardBodyText___vue_module_identifier__
)

/* harmony default export */ var components_UiCardBodyText = (UiCardBodyText_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiCardActions.vue


/* harmony default export */ var UiCardActions = ({
  functional: true,

  name: 'UiCardActions',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    var staticClass = 'card-actions';
    data.staticClass = data.staticClass ? data.staticClass + ' ' + staticClass : staticClass;
    children.forEach(function (child) {
      if (child.tag === 'button') {
        child.data.staticClass += 'card-action';
      }
    });

    return h('section', extends_default()({}, data), children);
  }
});
// CONCATENATED MODULE: ./src/components/UiCardActions.vue
var UiCardActions_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var UiCardActions___vue_template__ = null
/* template functional */
var UiCardActions___vue_template_functional__ = false
/* styles */
var UiCardActions___vue_styles__ = null
/* scopeId */
var UiCardActions___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var UiCardActions___vue_module_identifier__ = null
var UiCardActions_Component = UiCardActions_normalizeComponent(
  UiCardActions,
  UiCardActions___vue_template__,
  UiCardActions___vue_template_functional__,
  UiCardActions___vue_styles__,
  UiCardActions___vue_scopeId__,
  UiCardActions___vue_module_identifier__
)

/* harmony default export */ var components_UiCardActions = (UiCardActions_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UiCard.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var UiCard = ({
  name: 'card',
  props: {
    title: String,
    subTitle: String,
    bodyText: String,
    media: String,
    mediaHeight: {
      type: String,
      default: '320px'
    },
    themeDark: Boolean,
    img: String,

    tag: {
      type: String,
      default: 'div'
    },
    width: [String, Number]
  },
  components: {
    UiCardMedia: components_UiCardMedia,
    UiCardTitle: components_UiCardTitle,
    UiCardSubtitle: components_UiCardSubtitle,
    UiCardBodyText: components_UiCardBodyText,
    UiCardActions: components_UiCardActions
  },
  data: function data() {
    return {
      previewImageData: ''
    };
  },

  computed: {
    mediaStyle: function mediaStyle() {
      return {
        height: this.mediaHeight
      };
    },
    cardClasses: function cardClasses() {
      return {
        'card--theme-dark': this.themeDark
      };
    }
  },
  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9071a59c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UiCard.vue
var UiCard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card component",class:_vm.cardClasses},[(_vm.media)?_c('UiCardMedia',{staticClass:"card-media",style:(_vm.mediaStyle),attrs:{"media":_vm.media}},[_vm._t("media")],2):_vm._e(),_vm._v(" "),(_vm.title)?_c('UiCardTitle',{attrs:{"large":""}},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),(_vm.subTitle)?_c('UiCardSubtile',[_vm._v(_vm._s(_vm.subTitle))]):_vm._e(),_vm._v(" "),(_vm.bodyText || _vm.$slots.bodyText)?_c('UiCardBodyText',[_vm._t("card-body-text",[_vm._v(_vm._s(_vm.bodyText))])],2):_vm._e(),_vm._v(" "),(_vm.$slots.actions)?_c('UiCardActions',[_vm._t("actions")],2):_vm._e()],1)}
var UiCard_staticRenderFns = []
var UiCard_esExports = { render: UiCard_render, staticRenderFns: UiCard_staticRenderFns }
/* harmony default export */ var components_UiCard = (UiCard_esExports);
// CONCATENATED MODULE: ./src/components/UiCard.vue
function UiCard_injectStyle (ssrContext) {
  __webpack_require__("M+BR")
}
var UiCard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var UiCard___vue_template_functional__ = false
/* styles */
var UiCard___vue_styles__ = UiCard_injectStyle
/* scopeId */
var UiCard___vue_scopeId__ = "data-v-9071a59c"
/* moduleIdentifier (server only) */
var UiCard___vue_module_identifier__ = null
var UiCard_Component = UiCard_normalizeComponent(
  UiCard,
  components_UiCard,
  UiCard___vue_template_functional__,
  UiCard___vue_styles__,
  UiCard___vue_scopeId__,
  UiCard___vue_module_identifier__
)

/* harmony default export */ var src_components_UiCard = (UiCard_Component.exports);

// CONCATENATED MODULE: ./src/.env.js
var API_PORT = '4000';
var API_URL = 'http://localhost:' + API_PORT;
var DOMAIN_TITLE = 'http://djmelodie.com/';
var IG_URL = 'https://api.instagram.com/v1/users/self/media/recent/?access_token=';
var MEL_IG = 'https://www.instagram.com/djmelodie/';
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/IgCards.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var IgCards = ({
  name: 'IgCards',

  components: { UiCard: src_components_UiCard },

  data: function data() {
    return {
      cards: []
    };
  },
  created: function created() {
    // axios.get(`${IG_URL}33086999.93ecca8.ab5458e4958b4c0fb89b4221b24da597`).then(response => {
    //   console.log(response);
    // })
    this.igPhotos();
  },


  // computed: {
  //   cards () {
  //     return this.$store.state.toast.toastsList
  //   }
  // },

  methods: {
    igPhotos: function igPhotos() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var infoSource, jsonObject, userInfo, mediaArray, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, media, pic;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios_default.a.get('' + MEL_IG);

              case 3:
                infoSource = _context.sent;

                //infoSource.data contails the HTML from Axios
                jsonObject = infoSource.data.match(/<script type="text\/javascript">window\._sharedData = (.*)<\/script>/)[1].slice(0, -1);
                userInfo = JSON.parse(jsonObject);
                mediaArray = userInfo.entry_data.ProfilePage[0].graphql.user.edge_owner_to_timeline_media.edges.splice(0, 15);
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context.prev = 10;
                _iterator = get_iterator_default()(mediaArray);

              case 12:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context.next = 21;
                  break;
                }

                media = _step.value;
                pic = media.node;
                //process only if is an image

                if (!(pic.__typename && pic.__typename !== 'GraphImage')) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt('continue', 18);

              case 17:
                //push thumbnail src in the array
                _this.cards.push(pic.thumbnail_src);

              case 18:
                _iteratorNormalCompletion = true;
                _context.next = 12;
                break;

              case 21:
                _context.next = 27;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context['catch'](10);
                _didIteratorError = true;
                _iteratorError = _context.t0;

              case 27:
                _context.prev = 27;
                _context.prev = 28;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 30:
                _context.prev = 30;

                if (!_didIteratorError) {
                  _context.next = 33;
                  break;
                }

                throw _iteratorError;

              case 33:
                return _context.finish(30);

              case 34:
                return _context.finish(27);

              case 35:
                _context.next = 40;
                break;

              case 37:
                _context.prev = 37;
                _context.t1 = _context['catch'](0);

                console.error('unable to restieve photos. Reason: ' + _context.t1.toString());

              case 40:
                console.log(_this.cards);
                return _context.abrupt('return', _this.cards);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 37], [10, 23, 27, 35], [28,, 30, 34]]);
      }))();
    },
    viewImg: function viewImg() {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79c46dcf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IgCards.vue
var IgCards_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"ig-cards component row",attrs:{"name":"slide","tag":"div"}},_vm._l((_vm.cards),function(card,index){return _c('div',{key:index,staticClass:"col-xs-6 col-md-4 col-lg-3"},[_c('UiCard',{attrs:{"media":card},on:{"click":_vm.viewImg}})],1)}),0)}
var IgCards_staticRenderFns = []
var IgCards_esExports = { render: IgCards_render, staticRenderFns: IgCards_staticRenderFns }
/* harmony default export */ var components_IgCards = (IgCards_esExports);
// CONCATENATED MODULE: ./src/components/IgCards.vue
function IgCards_injectStyle (ssrContext) {
  __webpack_require__("lkL8")
}
var IgCards_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var IgCards___vue_template_functional__ = false
/* styles */
var IgCards___vue_styles__ = IgCards_injectStyle
/* scopeId */
var IgCards___vue_scopeId__ = "data-v-79c46dcf"
/* moduleIdentifier (server only) */
var IgCards___vue_module_identifier__ = null
var IgCards_Component = IgCards_normalizeComponent(
  IgCards,
  components_IgCards,
  IgCards___vue_template_functional__,
  IgCards___vue_styles__,
  IgCards___vue_scopeId__,
  IgCards___vue_module_identifier__
)

/* harmony default export */ var src_components_IgCards = (IgCards_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/Gallery.vue
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var Gallery = ({
  name: 'GalleryPage',

  components: {
    UiModal: src_components_UiModal,
    UiBaseIcon: components_icons_UiBaseIcon,
    IgCards: src_components_IgCards
  },

  data: function data() {
    return {
      title: null,
      headline: null,
      bgTxt: 'KALE',
      imgLinks: '/static/media/Southwind/southwind-1.jpg',
      isShowModal: {
        a: false,
        b: false
      }
    };
  },


  methods: {
    submitModalHanlder: function submitModalHanlder() {
      this.isShowModal = false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f2201de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Gallery.vue
var Gallery_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"portfolio page",attrs:{"data-page":"3"}},[_c('section',{staticClass:"hero-content fill-height"},[_c('div',{staticClass:"page-media"},[_c('IgCards')],1)])])}
var Gallery_staticRenderFns = []
var Gallery_esExports = { render: Gallery_render, staticRenderFns: Gallery_staticRenderFns }
/* harmony default export */ var pages_Gallery = (Gallery_esExports);
// CONCATENATED MODULE: ./src/pages/Gallery.vue
function Gallery_injectStyle (ssrContext) {
  __webpack_require__("2tdZ")
}
var Gallery_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Gallery___vue_template_functional__ = false
/* styles */
var Gallery___vue_styles__ = Gallery_injectStyle
/* scopeId */
var Gallery___vue_scopeId__ = "data-v-9f2201de"
/* moduleIdentifier (server only) */
var Gallery___vue_module_identifier__ = null
var Gallery_Component = Gallery_normalizeComponent(
  Gallery,
  pages_Gallery,
  Gallery___vue_template_functional__,
  Gallery___vue_styles__,
  Gallery___vue_scopeId__,
  Gallery___vue_module_identifier__
)

/* harmony default export */ var src_pages_Gallery = (Gallery_Component.exports);

// EXTERNAL MODULE: ./node_modules/fine-mq/dist/mq.js
var mq = __webpack_require__("z3RW");
var mq_default = /*#__PURE__*/__webpack_require__.n(mq);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layout/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ var layout = ({
  name: 'AppLayout',
  components: {
    AppHeader: src_layout_Header,
    AppFooter: src_layout_Footer,
    homePage: src_pages_Home,
    introPage: src_pages_Intro,
    contactPage: src_pages_Contact,
    GalleryPage: src_pages_Gallery
  },
  data: function data() {
    return {
      pages: ['index', 'intro', 'portfolio', 'contact'],
      currentpage: null,
      /*
      * Amount of space between top of screen and the section to highlight
      */
      offset: 52,
      clickToScroll: true,
      duration: 600,
      modifyUrl: true,
      /*
      * Must be a string with 4 values seperated by commas
      */
      bezierEasingValue: '.5,0,.35,1',
      observer: null,
      items: [],
      currentItem: null,
      lastActiveItem: null,
      scrollAnimationFrame: null,
      lastKnowScrollY: 0,
      currentScrollY: 0,
      ticking: false,
      idOfHeader: 'header',
      eleHeader: null,
      window: null,
      app: null,
      logo: null,
      wrapper: null,
      isVisible: false,
      firstScreen: null,
      timeLineIn: null,
      timeLineOut: null,
      screens: [],
      screen: null,
      screenNav: null,
      screenId: null,
      screenIndex: null,
      nav: null
    };
  },
  mounted: function mounted() {},
  created: function created() {},
  updated: function updated() {},

  watch: {
    '$route': 'animateIn'
  },
  methods: {
    animateIn: function animateIn() {
      var title = document.querySelector('.page-title');
      var headline = document.querySelector('.page-headline');
      var text = document.querySelector('.page-text');
      var media = document.querySelector('.page-media');
      // let bgColor = screen.getAttribute('data-bg-color');
      // let bg = screen.querySelector('.slide-bg');
      // bg.style.backgroundColor = bgColor;
      var timeLineIn = new gsap_all["a" /* TimelineMax */]().add(this.addTitle(title), 'start').add(this.addHeadline(headline), 'start+=.3').add(this.addText(text), 'start+=.4').add(this.addMedia(media), 'start +=.5');
    },
    addMedia: function addMedia(screen) {
      var tl = new gsap_all["a" /* TimelineMax */]();
      tl.fromTo(screen, 1, {
        autoAlpha: 0,
        x: '+100%'
      }, {
        autoAlpha: 1,
        x: '0%',
        ease: Power3.easeOut
      });
      return tl;
    },
    addText: function addText(screen) {
      var tl = new gsap_all["a" /* TimelineMax */]();
      tl.fromTo(screen, 1, {
        y: '-50%',
        opacity: 0
      }, {
        y: '0%',
        opacity: 1,
        ease: Power3.easeOut
      });
      return tl;
    },
    addTitle: function addTitle(screen) {
      var tl = new gsap_all["a" /* TimelineMax */]();
      tl.fromTo(screen, 1, {
        y: '-50%',
        opacity: 0
      }, {
        y: '0%',
        opacity: 1,
        ease: Power3.easeOut
      });
      return tl;
    },
    addHeadline: function addHeadline(screen) {
      var tl = new gsap_all["a" /* TimelineMax */]();
      tl.fromTo(screen, 1, {
        y: '-50%',
        opacity: 0
      }, {
        y: '0%',
        opacity: 1,
        ease: Power3.easeOut
      });
      return tl;
    },

    // --------
    // ENTERING
    // --------

    beforeEnter: function beforeEnter(el) {
      // ...
      // el.style.opacity = 0;
      // el.style.translateY = "-50%";
    },
    // the done callback is optional when
    // used in combination with CSS
    enter: function enter(el, done) {
      // ...
      // el.style.opacity = 1;
      // this.animateIn();
      // done()
    },
    afterEnter: function afterEnter(el) {
      // ...

    },
    enterCancelled: function enterCancelled(el) {
      // ...
    },

    // --------
    // LEAVING
    // --------

    beforeLeave: function beforeLeave(el) {
      // ...
    },
    // the done callback is optional when
    // used in combination with CSS
    leave: function leave(el, done) {
      // ...
      done();
    },
    afterLeave: function afterLeave(el) {
      // ...
    },
    // leaveCancelled only available with v-show
    leaveCancelled: function leaveCancelled(el) {
      // ...
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fef36bb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/index.vue
var layout_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper",attrs:{"id":"app"}},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"page-body"},[_c('transition',{on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.afterEnter,"enter-cancelled":_vm.enterCancelled,"before-leave":_vm.beforeLeave,"leave":_vm.leave,"after-leave":_vm.afterLeave,"leave-cancelled":_vm.leaveCancelled}},[_c('router-view')],1)],1),_vm._v(" "),_c('AppFooter')],1)}
var layout_staticRenderFns = []
var layout_esExports = { render: layout_render, staticRenderFns: layout_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_layout = (layout_esExports);
// CONCATENATED MODULE: ./src/layout/index.vue
function layout_injectStyle (ssrContext) {
  __webpack_require__("1mQu")
}
var layout_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var layout___vue_template_functional__ = false
/* styles */
var layout___vue_styles__ = layout_injectStyle
/* scopeId */
var layout___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var layout___vue_module_identifier__ = null
var layout_Component = layout_normalizeComponent(
  layout,
  selectortype_template_index_0_src_layout,
  layout___vue_template_functional__,
  layout___vue_styles__,
  layout___vue_scopeId__,
  layout___vue_module_identifier__
)

/* harmony default export */ var src_layout = (layout_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/modules/auth.js
/* harmony default export */ var auth = ({
  namespaced: true,
  state: {
    accessTokenExpDate: ''
  },

  mutations: {
    SET_ATOKEN_EXP_DATE: function SET_ATOKEN_EXP_DATE(state, expDate) {
      state.accessTokenExpDate = expDate;
    }
  }
});
// CONCATENATED MODULE: ./src/store/modules/user/userState.js
/* harmony default export */ var userState = ({
  currentUser: {
    id: '',
    role: '',
    name: '',
    email: ''
  }
});
// CONCATENATED MODULE: ./src/store/modules/user/userMutations.js
/* harmony default export */ var userMutations = ({
  SET_CURRENT_USER: function SET_CURRENT_USER(state, currentUserData) {
    state.currentUser = currentUserData;
  }
});
// CONCATENATED MODULE: ./src/store/modules/user/userGetters.js
/* harmony default export */ var userGetters = ({
  //
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("Zx67");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__("zwoO");
var possibleConstructorReturn_default = /*#__PURE__*/__webpack_require__.n(possibleConstructorReturn);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/inherits.js
var inherits = __webpack_require__("Pf15");
var inherits_default = /*#__PURE__*/__webpack_require__.n(inherits);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__("309y");
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);

// EXTERNAL MODULE: ./node_modules/lodash/isArray.js
var isArray = __webpack_require__("NGEn");
var isArray_default = /*#__PURE__*/__webpack_require__.n(isArray);

// CONCATENATED MODULE: ./src/services/util.js







/**
 * Return message for HTTP status code
 * @param {number} status - HTTP status code
 * @returns {string} Message of network operation
 */
function _getStatusMessage(status) {
  var message = '';
  switch (status) {
    case 200:
      message = 'All done. Request successfully executed';
      break;
    case 201:
      message = 'Data successfully created';
      break;
    case 400:
      message = 'Bad Request';
      break;
    case 401:
      message = 'Need auth';
      break;
    case 404:
      message = 'Not found';
      break;
    case 503:
      message = 'Service Unavailable';
      break;
    default:
      message = 'Something wrong. Client default error message';
      break;
  }
  return message;
}

function _getResponseErrorMessage(error) {
  if (error.response && error.response.data) return error.response.data.description;
  if (error.response && error.response.statusText) return error.response.statusText;
  if (error.message) return error.message;
  return '_getResponseErrorMessage can\'t handle error';
}

/**
 * Create instant, which represent response object
 * @param {Object} [data] - custom data
 * @param {Object} [response] - axios response object
 * @param {String} [message] - custom message to display
 */
var util_ResponseWrapper = function ResponseWrapper(response) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = arguments[2];

  classCallCheck_default()(this, ResponseWrapper);

  this.data = data;
  this.success = response.data.success;
  this.status = response.status;
  this.statusMessage = _getStatusMessage(this.status);
  this.message = message || null;
};

/**
 * Create instant, which represent error object
 * @param {Object} [error] - axios error object
 * @param {String} [message] - custom message to display
 */
var util_ErrorWrapper = function (_Error) {
  inherits_default()(ErrorWrapper, _Error);

  function ErrorWrapper(error, message) {
    classCallCheck_default()(this, ErrorWrapper);

    var _this = possibleConstructorReturn_default()(this, (ErrorWrapper.__proto__ || get_prototype_of_default()(ErrorWrapper)).call(this));

    _this.name = 'ErrorWrapper';
    _this.stack = new Error().stack;
    _this.success = error.response ? error.response.data.success : false;
    _this.status = error.response ? error.response.status : false;
    _this.statusMessage = _getStatusMessage(_this.status);
    _this.message = message || _getResponseErrorMessage(error);
    return _this;
  }

  return ErrorWrapper;
}(Error);

/**
 * Uses to clear request data before send it
 * Client shouldn't change entity id
 * @param data
 * @return {{}}
 */
function clearData(data) {
  var result = {};
  forEach_default()(data, function (item, propName) {
    if (isArray_default()(item) && item.length) {
      result[propName] = item;
    }
    if (!isArray_default()(item) && item && propName !== 'id') {
      result[propName] = item;
    }
  });
  return result;
}
// CONCATENATED MODULE: ./src/services/auth.service.js









/**
 ******************************
 * @API
 ******************************
 */

function makeLogin(_ref) {
  var email = _ref.email,
      password = _ref.password;

  return new promise_default.a(function (resolve, reject) {
    axios_default.a.post(API_URL + '/auth/signin', { email: email, password: password }).then(function (response) {
      _setAuthData(response);
      return resolve(new util_ResponseWrapper(response, response.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function makeLogout() {
  return new promise_default.a(function (resolve, reject) {
    new http_init({ auth: true }).post('auth/signout').then(function (response) {
      _resetAuthData();
      src_router.push({ name: 'index' });
      return resolve(new util_ResponseWrapper(response, response.data));
    }).catch(function (error) {
      return reject(new util_ErrorWrapper(error));
    });
  });
}

function refreshTokens() {
  return new promise_default.a(function (resolve, reject) {
    axios_default.a.post(API_URL + '/auth/refresh-tokens', { refreshToken: getRefreshToken() }).then(function (response) {
      _setAuthData(response);
      return resolve(new util_ResponseWrapper(response, response.data));
    }).catch(function (error) {
      if (error.response.data.badRefreshToken) {
        console.log('http.init.js >> badRefreshToken: true');
        _resetAuthData();
        src_router.push({ name: 'index' });
        return reject(new util_ErrorWrapper(error));
      }
      if (error.response.data.refreshTokenExpiredError) {
        console.log('http.init.js >> refreshTokenExpiredError');
        _resetAuthData();
        src_router.push({ name: 'index' });
        return reject(new util_ErrorWrapper(error));
      }
    });
  });
}

/**
 ******************************
 * @methods
 ******************************
 */

function isAccessTokenExpired() {
  var accessTokenExpDate = store.state.auth.accessTokenExpDate - 1;
  var nowTime = Math.floor(new Date().getTime() / 1000);

  return accessTokenExpDate <= nowTime;
}

function getRefreshToken() {
  return localStorage.getItem('refreshToken');
}

function getAccessToken() {
  return localStorage.getItem('accessToken');
}

function _resetAuthData() {
  // reset userData in store
  store.commit('user/SET_CURRENT_USER', {});
  store.commit('auth/SET_ATOKEN_EXP_DATE', null);
  // reset tokens in localStorage
  localStorage.setItem('refreshToken', '');
  localStorage.setItem('accessToken', '');
}

function _setAuthData(response) {
  localStorage.setItem('refreshToken', response.data.refreshToken);
  localStorage.setItem('accessToken', response.data.accessToken);
  store.commit('auth/SET_ATOKEN_EXP_DATE', response.data.expires_in);
}
// CONCATENATED MODULE: ./src/services/http.init.js



/**
 * HTTP request layer
 * if auth is required return patched axios instance(with access token in headers)
 * else return clear axios instance
 */






var http_init_Http = function () {
  function Http(status) {
    classCallCheck_default()(this, Http);

    this.isAuth = status && status.auth ? status.auth : false;
    this.instance = axios_default.a.create({
      baseURL: API_URL
    });

    return this.init();
  }

  createClass_default()(Http, [{
    key: 'init',
    value: function init() {
      if (this.isAuth) {
        this.instance.interceptors.request.use(function (request) {
          request.headers['token'] = getAccessToken();
          // if access token expired and refreshToken is exist >> go to API and get new access token
          if (isAccessTokenExpired() && getRefreshToken()) {
            return refreshTokens().then(function (response) {
              request.headers['token'] = response.data.accessToken;
              return request;
            }).catch(function (error) {
              return console.log(error);
            });
          } else {
            return request;
          }
        }, function (error) {
          return promise_default.a.reject(error);
        });

        return this.instance;
      }
      return this.instance;
    }
  }]);

  return Http;
}();

/* harmony default export */ var http_init = (http_init_Http);
// CONCATENATED MODULE: ./src/services/base.service.js







var base_service_BaseService = function () {
  function BaseService() {
    classCallCheck_default()(this, BaseService);

    if (!this.entity) {
      throw new Error('Child service class not provide entity');
    }
  }

  /**
   * ------------------------------
   * @HELPERS
   * ------------------------------
   */

  createClass_default()(BaseService, [{
    key: 'request',
    value: function request() {
      var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { auth: false };

      return new http_init(status);
    }
  }, {
    key: 'responseWrapper',
    value: function responseWrapper() {
      for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
        rest[_key] = arguments[_key];
      }

      return new (Function.prototype.bind.apply(util_ResponseWrapper, [null].concat(rest)))();
    }
  }, {
    key: 'errorWrapper',
    value: function errorWrapper() {
      for (var _len2 = arguments.length, rest = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        rest[_key2] = arguments[_key2];
      }

      return new (Function.prototype.bind.apply(util_ErrorWrapper, [null].concat(rest)))();
    }

    /**
     * ------------------------------
     * @API_CALLS_PUBLIC
     * ------------------------------
     */

  }, {
    key: 'getListPublic',
    value: function getListPublic() {
      var _this = this;

      var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var params = extends_default()({}, parameters);
      return new promise_default.a(function (resolve, reject) {
        return _this.request().get('' + _this.entity, { params: params }).then(function (response) {
          var data = {
            content: response.data.data.results,
            total: response.data.data.total
          };
          resolve(_this.responseWrapper(response, data));
        }).catch(function (error) {
          var message = error.response.data ? error.response.data.error : error.response.statusText;
          reject(_this.errorWrapper(error, message));
        });
      });
    }
  }, {
    key: 'getByIdPublic',
    value: function getByIdPublic() {
      var _this2 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.required();

      return new promise_default.a(function (resolve, reject) {
        return _this2.request().get(_this2.entity + '/' + id).then(function (response) {
          return resolve(_this2.responseWrapper(response, response.data.data));
        }).catch(function (error) {
          var message = error.response.data ? error.response.data.error : error.response.statusText;
          reject(_this2.errorWrapper(error, message));
        });
      });
    }

    /**
     * ------------------------------
     * @API_CALLS_PRIVATE
     * ------------------------------
     */

  }, {
    key: 'getById',
    value: function getById() {
      var _this3 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.required();

      return new promise_default.a(function (resolve, reject) {
        return _this3.request({ auth: true }).get(_this3.entity + '/' + id).then(function (response) {
          return resolve(_this3.responseWrapper(response, response.data.data));
        }).catch(function (error) {
          var message = error.response.data ? error.response.data.error : error.response.statusText;
          reject(_this3.errorWrapper(error, message));
        });
      });
    }
  }, {
    key: 'create',
    value: function create() {
      var _this4 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.required();

      return new promise_default.a(function (resolve, reject) {
        return _this4.request({ auth: true }).post('' + _this4.entity, data).then(function (response) {
          return resolve(_this4.responseWrapper(response, response.data.data));
        }).catch(function (error) {
          return reject(_this4.errorWrapper(error));
        });
      });
    }
  }, {
    key: 'update',
    value: function update() {
      var _this5 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.required();
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.required();

      return new promise_default.a(function (resolve, reject) {
        return _this5.request({ auth: true }).patch(_this5.entity + '/' + id, data).then(function (response) {
          return resolve(_this5.responseWrapper(response, response.data.data));
        }).catch(function (error) {
          return reject(_this5.errorWrapper(error));
        });
      });
    }
  }, {
    key: 'remove',
    value: function remove() {
      var _this6 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.required();

      return new promise_default.a(function (resolve, reject) {
        return _this6.request({ auth: true }).delete(_this6.entity + '/' + id).then(function (response) {
          return resolve(_this6.responseWrapper(response, response.data.data));
        }).catch(function (error) {
          return reject(_this6.errorWrapper(error));
        });
      });
    }
  }]);

  return BaseService;
}();

/* harmony default export */ var base_service = (base_service_BaseService);
// CONCATENATED MODULE: ./src/services/users.service.js








var users_service_UsersService = function (_BaseService) {
  inherits_default()(UsersService, _BaseService);

  function UsersService() {
    classCallCheck_default()(this, UsersService);

    return possibleConstructorReturn_default()(this, (UsersService.__proto__ || get_prototype_of_default()(UsersService)).apply(this, arguments));
  }

  createClass_default()(UsersService, [{
    key: 'getCurrent',
    value: function getCurrent() {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        return _this2.request({ auth: true }).get(_this2.entity + '/current').then(function (response) {
          return resolve(_this2.responseWrapper(response, response.data.data));
        }).catch(function (error) {
          var message = error.response.data ? error.response.data.error : error.response.statusText;
          reject(_this2.errorWrapper(error, message));
        });
      });
    }
  }, {
    key: 'getPostsByUserId',
    value: function getPostsByUserId() {
      var _this3 = this;

      var user_id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.required();

      return new promise_default.a(function (resolve, reject) {
        return _this3.request({ auth: true }).get(_this3.entity + '/' + user_id + '/posts').then(function (response) {
          var data = {
            content: response.data.data,
            total: response.data.data.total ? response.data.data.total : ''
          };
          resolve(_this3.responseWrapper(response, data));
        }).catch(function (error) {
          var message = error.response.data ? error.response.data.error : error.response.statusText;
          reject(_this3.errorWrapper(error, message));
        });
      });
    }
  }, {
    key: 'entity',
    get: function get() {
      return 'users';
    }
  }]);

  return UsersService;
}(base_service);

/* harmony default export */ var users_service = (new users_service_UsersService());
// CONCATENATED MODULE: ./src/store/modules/user/userActions.js


/* harmony default export */ var userActions = ({
  getCurrent: function getCurrent(_ref) {
    var commit = _ref.commit;

    return users_service.getCurrent().then(function (user) {
      return commit('SET_CURRENT_USER', user.data);
    }).catch(function (error) {
      return commit('toast/NEW', { type: 'error', message: error.message }, { root: true });
    });
  }
});
// CONCATENATED MODULE: ./src/store/modules/user/index.js





/* harmony default export */ var user = ({
  namespaced: true,
  state: userState,
  mutations: userMutations,
  getters: userGetters,
  actions: userActions
});
// CONCATENATED MODULE: ./src/store/modules/dom.js
/**
 * anything that relates to DOM
 */
/* harmony default export */ var dom = ({
  namespaced: true,
  state: {
    windowWidth: 0,
    /**
     * breakpoint constants
     */
    widthExtraSmall: 320,
    widthSmall: 640,
    widthTablet: 1024
  },

  mutations: {
    SET_WINDOW_WIDTH: function SET_WINDOW_WIDTH(state, value) {
      state.windowWidth = value;
    }
  },

  getters: {
    isExtraSmall: function isExtraSmall(state) {
      return state.windowWidth <= state.widthExtraSmall;
    },
    isSmall: function isSmall(state) {
      return state.windowWidth <= state.widthSmall;
    },
    isTablet: function isTablet(state) {
      return state.windowWidth <= state.widthTablet;
    },
    isDesktop: function isDesktop(state) {
      return state.windowWidth > state.widthTablet;
    }
  }
});
// CONCATENATED MODULE: ./src/store/modules/toast.js

/**
 * toast notification module
 */
/* harmony default export */ var modules_toast = ({
  namespaced: true,
  state: {
    toastsList: []
  },

  mutations: {
    NEW: function NEW(state, payload) {
      var toast = {
        id: new Date().getTime(),
        message: typeof payload === 'string' ? payload : payload.message,
        type: payload.type || 'default',
        duration: payload.duration || 5000
      };
      if (payload.type === 'error') {
        toast.duration = 0;
        console.error(payload.message);
      }
      state.toastsList.push(extends_default()({}, toast));
    },
    REMOVE: function REMOVE(state, payload) {
      state.toastsList = state.toastsList.filter(function (_ref) {
        var id = _ref.id;
        return id !== payload.id;
      });
    },
    CLEAR_LIST: function CLEAR_LIST(state) {
      state.toastsList = [];
    }
  }
});
// CONCATENATED MODULE: ./src/store/modules/news/newsState.js
/* harmony default export */ var newsState = ({
  loading: false,
  error: false,
  items: [],
  pagination: {
    limit: 10,
    page: 0,
    total: 0
  }
});
// CONCATENATED MODULE: ./src/store/modules/news/newsMutations.js
/* harmony default export */ var newsMutations = ({
  SET_ITEMS: function SET_ITEMS(state, data) {
    state.items = data;
  },
  SET_PAGINATION: function SET_PAGINATION(state, payload) {
    state.pagination = {
      page: payload.page || state.pagination.page,
      limit: payload.limit || state.pagination.limit,
      total: payload.total || state.pagination.total
    };
  },
  SET_ERROR: function SET_ERROR(state, data) {
    state.error = data;
  },
  SET_LOADING: function SET_LOADING(state, data) {
    state.loading = data;
  }
});
// CONCATENATED MODULE: ./src/store/modules/news/newsGetters.js
/* harmony default export */ var newsGetters = ({
  isEmpty: function isEmpty(state) {
    return !state.items.length;
  }
});
// CONCATENATED MODULE: ./src/services/posts.service.js







var posts_service_PostsService = function (_BaseService) {
  inherits_default()(PostsService, _BaseService);

  function PostsService() {
    classCallCheck_default()(this, PostsService);

    return possibleConstructorReturn_default()(this, (PostsService.__proto__ || get_prototype_of_default()(PostsService)).apply(this, arguments));
  }

  createClass_default()(PostsService, [{
    key: 'entity',
    get: function get() {
      return 'posts';
    }
  }]);

  return PostsService;
}(base_service);

/* harmony default export */ var posts_service = (new posts_service_PostsService());
// CONCATENATED MODULE: ./src/store/modules/news/newsActions.js


/* harmony default export */ var newsActions = ({
  getListPublic: function getListPublic(_ref, payload) {
    var state = _ref.state,
        commit = _ref.commit;

    commit('SET_LOADING', true);
    return posts_service.getListPublic(payload.params).then(function (response) {
      commit('SET_ITEMS', response.data.content);
      commit('SET_PAGINATION', { total: response.data.total });
    }).catch(function (error) {
      return commit('SET_ERROR', error.message);
    }).finally(function () {
      return commit('SET_LOADING', false);
    });
  }
});
// CONCATENATED MODULE: ./src/store/modules/news/index.js





/* harmony default export */ var news = ({
  namespaced: true,
  state: newsState,
  mutations: newsMutations,
  getters: newsGetters,
  actions: newsActions
});
// CONCATENATED MODULE: ./src/store/modules/profilePosts/profilePostsState.js
/* harmony default export */ var profilePostsState = ({
  loading: false,
  error: false,
  items: [],
  pagination: {
    limit: 10,
    page: 0,
    total: 0
  }
});
// CONCATENATED MODULE: ./src/store/modules/profilePosts/profilePostsMutations.js
/* harmony default export */ var profilePostsMutations = ({
  SET_ITEMS: function SET_ITEMS(state, data) {
    state.items = data;
  },
  SET_PAGINATION: function SET_PAGINATION(state, payload) {
    state.pagination = {
      page: payload.page || state.pagination.page,
      limit: payload.limit || state.pagination.limit,
      total: payload.total || state.pagination.total
    };
  },
  SET_ERROR: function SET_ERROR(state, data) {
    state.error = data;
  },
  SET_LOADING: function SET_LOADING(state, data) {
    state.loading = data;
  }
});
// CONCATENATED MODULE: ./src/store/modules/profilePosts/profilePostsGetters.js
/* harmony default export */ var profilePostsGetters = ({
  isEmpty: function isEmpty(state) {
    return !state.items.length;
  }
});
// CONCATENATED MODULE: ./src/store/modules/profilePosts/profilePostsActions.js


/* harmony default export */ var profilePostsActions = ({
  getCurrentUserPosts: function getCurrentUserPosts(_ref, payload) {
    var state = _ref.state,
        commit = _ref.commit,
        rootState = _ref.rootState;

    commit('SET_LOADING', true);
    return users_service.getPostsByUserId(rootState.user.currentUser.id).then(function (response) {
      commit('SET_ITEMS', response.data.content);
      commit('SET_PAGINATION', { total: response.data.total });
    }).catch(function (error) {
      return commit('SET_ERROR', error.message);
    }).finally(function () {
      return commit('SET_LOADING', false);
    });
  }
});
// CONCATENATED MODULE: ./src/store/modules/profilePosts/index.js





/* harmony default export */ var profilePosts = ({
  namespaced: true,
  state: profilePostsState,
  mutations: profilePostsMutations,
  getters: profilePostsGetters,
  actions: profilePostsActions
});
// CONCATENATED MODULE: ./src/store/modules/index.js







/* harmony default export */ var modules = ({
  auth: auth,
  user: user,
  dom: dom,
  toast: modules_toast,
  news: news,
  profilePosts: profilePosts
});
// CONCATENATED MODULE: ./src/store/index.js




vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: modules,
  strict: "production" === 'development'
}));
// CONCATENATED MODULE: ./src/router/middlewares.js



/**
 * Current user state initialization
 * @WARN Must be always first in middleware chain
 */
function initCurrentUserStateMiddleware(to, from, next) {
  var currentUserId = store.state.user.currentUser.id;

  if (getRefreshToken() && !currentUserId) {
    return refreshTokens().then(function () {
      return store.dispatch('user/getCurrent');
    }).then(function () {
      return next();
    }).catch(function (error) {
      return console.log(error);
    });
  }
  next();
}

/**
 * Check access permission to auth routes
 */
function checkAccessMiddleware(to, from, next) {
  var currentUserId = store.state.user.currentUser.id;
  var isAuthRoute = to.matched.some(function (item) {
    return item.meta.isAuth;
  });

  if (isAuthRoute && currentUserId) return next();
  if (isAuthRoute) return next({ name: 'login' });
  next();
}

function setPageTitleMiddleware(to, from, next) {
  var pageTitle = to.matched.find(function (item) {
    return item.meta.title;
  });

  if (pageTitle) window.document.title = pageTitle.meta.title;
  next();
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/NotFound.vue
//
//
//
//
//
//

/* harmony default export */ var NotFound = ({
  name: 'NotFound'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7628754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/NotFound.vue
var NotFound_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var NotFound_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404")])])}]
var NotFound_esExports = { render: NotFound_render, staticRenderFns: NotFound_staticRenderFns }
/* harmony default export */ var pages_NotFound = (NotFound_esExports);
// CONCATENATED MODULE: ./src/pages/NotFound.vue
var NotFound_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var NotFound___vue_template_functional__ = false
/* styles */
var NotFound___vue_styles__ = null
/* scopeId */
var NotFound___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NotFound___vue_module_identifier__ = null
var NotFound_Component = NotFound_normalizeComponent(
  NotFound,
  pages_NotFound,
  NotFound___vue_template_functional__,
  NotFound___vue_styles__,
  NotFound___vue_scopeId__,
  NotFound___vue_module_identifier__
)

/* harmony default export */ var src_pages_NotFound = (NotFound_Component.exports);

// CONCATENATED MODULE: ./src/router/util.js

/**
 * get query params from URL(via default vue query object)
 * and pass it to component props
 */
function routePropResolver(routeOptions) {
  var query = routeOptions.query;

  var resultQuery = {};

  keys_default()(query).forEach(function (key) {
    // parse strings
    if (query[key].length && !['0', 'null', 'undefined', 'NaN'].includes(query[key])) {
      resultQuery[key] = query[key];
    }
    // parse numbers
    if (parseInt(query[key])) {
      resultQuery[key] = +query[key];
    }
  });
  return resultQuery;
}

/**
 * validate route limit
 * API have default limit equals to 10, so we don't need send it
 * @param {int} limit
 * @return {boolean}
 */
function isValidLimitQuery(limit) {
  return [20, 30, 40, 50, 100].includes(+limit);
}

/**
 * validate route page
 * API have default page equals to 0, so we don't need send it
 * @param {int} page
 * @return {boolean}
 */
function isValidPageQuery(page) {
  return +page >= 1;
}
// CONCATENATED MODULE: ./src/router/routes.js
// single pages









var routes = [{
  path: '/',
  name: 'index',
  component: src_pages_Home,
  meta: { title: DOMAIN_TITLE + ' | home' }
}, {
  path: '/intro',
  name: 'intro',
  component: src_pages_Intro,
  meta: { title: DOMAIN_TITLE + ' | intro' }
}, {
  path: '/contact',
  name: 'contact',
  component: src_pages_Contact,
  meta: { title: DOMAIN_TITLE + ' | contact' }
}, {
  path: '/gallery',
  name: 'gallery',
  component: src_pages_Gallery,
  meta: { title: DOMAIN_TITLE + ' | gallery' }
}, {
  path: '*',
  component: src_pages_NotFound,
  meta: { title: DOMAIN_TITLE + ' | not found' }
}];
// CONCATENATED MODULE: ./src/router/index.js






vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router = new vue_router_esm["a" /* default */]({
  linkActiveClass: 'is-active',
  mode: 'history',
  routes: routes
});

router.beforeEach(initCurrentUserStateMiddleware);
router.beforeEach(checkAccessMiddleware);
router.beforeEach(setPageTitleMiddleware);

/* harmony default export */ var src_router = (router);
// CONCATENATED MODULE: ./src/global.helpers.js
/* harmony default export */ var global_helpers = (function () {
  window.required = function (paramName) {
    throw new Error((paramName || 'Required') + ' parameter not supplied');
  };
});
// CONCATENATED MODULE: ./src/plugins/translations.js
/* harmony default export */ var translations = ({
  en: {
    form: {
      name: "Your Name",
      email: "Your Email",
      message: "Your Message",
      terms: "I accept the terms and conditions",
      additionalInfo: "Additional info",
      submitted: "The form is submitted!",
      sentInfo: "Here is the info you sent:",
      return: "Return to the form",
      submit: "Ready to Send",
      submitting: "Submitting",
      charactersLeft: "You have {charCount} character left. | You have {charCount} characters left."
    },
    error: {
      invalidFields: "Following fields have an invalid or a missing value:",
      general: "An error happened during submit.",
      generalMessage: "Form sending failed due to technical problems. Try again later.",
      fieldRequired: "{field} is required.",
      fieldInvalid: "{field} is invalid or missing.",
      fieldMaxLength: "{field} maximum characters exceeded."
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/currentUser.js
/* harmony default export */ var currentUser = ({
  computed: {
    $currentUser: function $currentUser() {
      return this.$store.state.user.currentUser;
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/jumpTo.js
/**
 * Jump to some DOM element
 */
/* harmony default export */ var jumpTo = ({
  methods: {
    $jumpTo: function $jumpTo(selector) {
      var el = document.querySelectorAll(selector)[0];
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      } else {
        throw new Error('Element not supplied.');
      }
    }
  }

  // Usage example >>
  // someSubmitHandler () {
  //   this.$v.$touch()
  // // must be used only after touch function
  //   this.$nextTick(() => {
  //     if (this.$v.item.$invalid) this.jumpTo('.is-error')
  //   });
  // };

});
// CONCATENATED MODULE: ./src/config/datetime.js
/* harmony default export */ var datetime = ({
  FORMAT_DATE: 'MM/DD/YYYY',
  FORMAT_TIME: 'hh:mm:ss',
  FORMAT_DATETIME: 'MM/DD/YYYY hh:mm:ss'
});
// CONCATENATED MODULE: ./src/config/index.js



// CONCATENATED MODULE: ./src/mixins/formatDateTime.js


/* harmony default export */ var formatDateTime = ({
  computed: {
    $FORMAT_DATETIME: function $FORMAT_DATETIME() {
      return {
        DATE: datetime.FORMAT_DATE,
        TIME: datetime.FORMAT_TIME,
        DATETIME: datetime.FORMAT_DATETIME
      };
    }
  }
});
// CONCATENATED MODULE: ./src/mixins/index.js
/**
 * import and init global mixins
 */







vue_esm["a" /* default */].mixin(currentUser);
vue_esm["a" /* default */].mixin(jumpTo);
vue_esm["a" /* default */].mixin(formatDateTime);
// CONCATENATED MODULE: ./src/plugins/globalEventBus.js

var eventBus = new vue_esm["a" /* default */]();

/* harmony default export */ var globalEventBus = ({
  install: function install(Vue) {
    Vue.prototype.$bus = eventBus;
  }
});
// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/fine-mq/dist/fine-mq.es.js
var fine_mq_es = __webpack_require__("yKqu");

// EXTERNAL MODULE: ./node_modules/vuelidate/lib/index.js
var lib = __webpack_require__("ESwS");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./src/plugins/index.js
/**
 * import and init global plugins
 */










vue_esm["a" /* default */].use(globalEventBus);
vue_esm["a" /* default */].use(vue_awesome_swiper_default.a);
vue_esm["a" /* default */].use(fine_mq_es["a" /* default */]);
vue_esm["a" /* default */].use(lib_default.a);
vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);
vue_esm["a" /* default */].use(vue_recaptcha_es["a" /* default */]);
// EXTERNAL MODULE: ./node_modules/vue-plyr/dist/vue-plyr.es.js
var vue_plyr_es = __webpack_require__("GUoS");

// EXTERNAL MODULE: ./node_modules/vue-plyr/dist/vue-plyr.css
var vue_plyr = __webpack_require__("Kv5V");
var vue_plyr_default = /*#__PURE__*/__webpack_require__.n(vue_plyr);

// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/main.js
var main = __webpack_require__("sA6N");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./src/thirdParty/index.js
/**
 * import and init third party
 * components/validators and other dependencies
 */



// import VueMaterial from 'vue-material'
// import 'vue-material/dist/vue-material.css'

// Vue.use(VueMaterial)




vue_esm["a" /* default */].use(main, {
  load: {
    //Todo: Change the mockup key to colorbloqkey
    key: 'AIzaSyCuECgyGmMDm2me1DqZyEVHhQyQb1WPRuQ',
    libraries: 'places,drawing,visualization'
  }
});
// EXTERNAL MODULE: ./src/scss/style.scss
var style = __webpack_require__("xnyV");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/assets/fonts/bebasneue.css
var bebasneue = __webpack_require__("Rtn+");
var bebasneue_default = /*#__PURE__*/__webpack_require__.n(bebasneue);

// CONCATENATED MODULE: ./src/app.init.js


















global_helpers();
vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].config.formApiUrl = Object({"NODE_ENV":"production"}).FORM_API_URL;

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: 'en',
  fallbackLocale: 'en',
  messages: translations
});

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  name: 'Root',
  template: '<AppLayout/>',
  components: { AppLayout: src_layout },
  el: '#app',
  router: src_router,
  store: store,
  i18n: i18n,

  mounted: function mounted() {
    store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth);
    window.addEventListener('resize', function () {
      return store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', function () {
      return store.commit('dom/SET_WINDOW_WIDTH', window.innerWidth);
    });
  }
});

/***/ }),

/***/ "1mQu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2tdZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "36Ip":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/map.vue
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var map = ((function (x) {
  return x.default || x;
})(__webpack_require__("hOwk")));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6839df3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/map.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_map = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/map.vue
function injectStyle (ssrContext) {
  __webpack_require__("dtWn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  map,
  components_map,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dist_components_map = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/infoWindow.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var infoWindow = ((function (x) {
  return x.default || x;
})(__webpack_require__("WgA/")));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25e3f758","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/infoWindow.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_infoWindow = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/infoWindow.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  infoWindow,
  components_infoWindow,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dist_components_infoWindow = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6JGP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7XOo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Z9s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B6bC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CjMs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Cr0F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DK+H":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kiyy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Kv5V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M+BR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Rtn+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TlMV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XKrC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aId2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d7EU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dtWn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ecqj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fDp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ifLO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lkL8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lpCi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue2-google-maps/dist/components/autocomplete.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var autocomplete = ((function (x) {
  return x.default || x;
})(__webpack_require__("hQTS")));
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e569f3e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue2-google-maps/dist/components/autocomplete.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_autocomplete = (esExports);
// CONCATENATED MODULE: ./node_modules/vue2-google-maps/dist/components/autocomplete.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  autocomplete,
  components_autocomplete,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var dist_components_autocomplete = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "v+3r":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v6gy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xnyV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["0Flw"]);


// WEBPACK FOOTER //
// static/js/app.c26baeb75af1dfb2f6ec.js